<template>
    <div>
        <b-modal
            :id="ModalId"
            size="lg"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            scrollable
            centered
            :title="TitleWindow"
            :visible="true"
            @ok="this.emitEventOK"
            @hide="emitEventHide"
        >
            <div
                v-if="isListing && !this.isOpenInEmployeeInbox"
                id="ContainerTreatmentPlanOutComeBase"
            >
                <div class="row">
                    <div class="col-12">
                        <MdTitleRegInfo
                            v-bind:RegistrationInfo="PatientTitle"
                            v-bind:titlePrefix="$t('Shared.treatmentplan')"
                            v-bind:IsClinical="IsClinical"
                            v-bind:titleRef="'titleElementTreatmentplanBase'"
                            v-bind:patientCode="this.PatientCode"
                        >
                        </MdTitleRegInfo>

                        <div
                            class="alert alert-fill-warning d-flex align-items-center m-3"
                            role="alert"
                            v-if="isReadOnly"
                        >
                            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                            <div class="flex-grow-1">
                                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                            </div>
                        </div>
                        <div class="row" v-if="visibleTable">
                            <div class="col-sm-12 col-md-12 mb-4">
                                <div
                                    class="textlabel"
                                    :data-label="this.$t('Shared.SearchElements')"
                                >
                                    <div class="input-group" dir="ltr">
                                        <input
                                            type="text"
                                            class="form-control"
                                            :dir="dirInput"
                                            v-model="parameter.SearchCriteria"
                                            @keyup.enter="Search"
                                        />
                                        <div class="input-group-append">
                                            <div class="input-group-append">
                                                <MdButton
                                                    v-bind:Name="'btnsearchinput'"
                                                    v-bind:VariantProp="
                                                        'btn btn-sm search-attached'
                                                    "
                                                    v-bind:IconClass="'mdi mdi-magnify'"
                                                    v-on:click="Search"
                                                >
                                                </MdButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="!visibleTable" class="mx-3 text-muted">
                    {{ $t('treatmentplanList.NoAdmRecId') }}
                </p>
                <div class="row" v-if="visibleTable">
                    <div class="col-12 mt-2">
                        <MdTitle
                            v-bind:Text="$t('Shared.SearchResult')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleSearch'"
                        />
                        <div class="row">
                            <div class="col-md-12">
                                <MdTable
                                    v-bind:fields="fields"
                                    v-bind:items="items"
                                    v-bind:totalRows="totalRows"
                                    v-bind:isReadOnly="isReadOnly"
                                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                                    v-bind:currentPage="currentPage"
                                    v-bind:perPage="perPage"
                                    v-bind:pageOptions="pageOptions"
                                    :onRowSelected="onRowSelected"
                                    :viewIconEvent="ViewTP"
                                    :onFiltered="onFiltered"
                                    :pageChanged="pageChanged"
                                    :perPageFunction="PerPageFunction"
                                >
                                </MdTable>
                            </div>
                        </div>
                    </div>
                </div>
                <!--111111-->
            </div>

            <div
                v-show="TreatmentPlanType === 'TfmWileyTreatmentPlanNotes'"
                id="ContainerTreatmentPlanListWiley"
            >
                <div class="row">
                    <div class="col-12">
                        <MdTitleRegInfo
                            v-if="VisibleBar"
                            v-bind:RegistrationInfo="RegistrationInfo"
                            v-bind:titlePrefix="$t('Shared.treatmentplan')"
                            v-bind:IsClinical="true"
                            v-bind:titleRef="'titleElementTreatmentplan'"
                            v-bind:patientCode="this.PatientCode"
                        >
                        </MdTitleRegInfo>

                        <div
                            class="alert alert-fill-warning d-flex align-items-center m-3"
                            role="alert"
                            v-if="isReadOnly"
                        >
                            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                            <div class="flex-grow-1">
                                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <MdButton
                                    v-bind:Label="$t('treatmentplan.AddProblem')"
                                    v-bind:ClassProp="
                                        this.isReadOnly
                                            ? 'btn btn-primary my-3 btn-block'
                                            : 'btn btn-primary my-3 btn-block btn-login'
                                    "
                                    v-bind:IconClass="'ti-plus pr-1'"
                                    v-on:click="AddProblemWiley"
                                    v-bind:isReadOnly="this.isReadOnly || ReadOnlyProp"
                                    v-bind:Name="'btn_add_problem'"
                                >
                                </MdButton>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-4">
                                <div
                                    class="textlabel"
                                    :data-label="this.$t('Shared.SearchElements')"
                                >
                                    <div class="input-group" dir="ltr">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="parameter.SearchCriteria"
                                            :dir="dirInput"
                                            @keyup.enter="SearchProblems"
                                            :placeholder="$t('treatmentplanList.sProbDes')"
                                        />

                                        <div class="input-group-append">
                                            <MdButton
                                                v-bind:Name="'btnsearchinput'"
                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                v-on:click="SearchProblems"
                                            >
                                            </MdButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <MdSelect
                                    v-bind:Label="$t('MdNote.Versions')"
                                    v-bind:Options="VersionList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:AllowEmpty="false"
                                    v-bind:NoEmitChange="true"
                                    v-bind:Model="VersionModel"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownVersions"
                                />
                            </div>
                        </div>
                        <div
                            class="alert alert-fill-warning d-flex align-items-center m-3"
                            role="alert"
                            v-if="this.VersionModel.code > 0"
                        >
                            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                            <div class="flex-grow-1">
                                <span>{{ $t('MdNote.pNoteVersionMsg') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div v-if="VisibleNoRecords" class="empty-row-banner m-3">
                            <div class="text-center my-2">
                                {{ $t('treatmentplanList.nProbYet') }}
                            </div>
                        </div>
                        <div v-if="VisibleNoRecordsWithFilter" class="empty-row-banner m-3">
                            <div class="text-center my-2">
                                {{ $t('treatmentplanList.nProbMa') }}
                            </div>
                        </div>

                        <div
                            v-for="(item, index) in this.TreatmentPlan.problems"
                            :key="index"
                            class="IncidentContainerBox"
                        >
                            <div class="pull-right containerBoxTitle ml-5">
                                <!-- <b-icon icon="pencil-fill" @click="EditProblem(item)" v-b-tooltip.hover.top="'Edit Problem'" scale=".5" font-scale="1.6" variant="light"></b-icon>-->
                                <b-icon
                                    icon="printer-fill"
                                    @click="PrintOnlyProblem(item)"
                                    v-b-tooltip.hover.top="$t('treatmentplanList.printProb')"
                                    scale=".5"
                                    font-scale="1.6"
                                    variant="light"
                                ></b-icon>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="grid-margin stretch-card">
                                        <div class="card activeCard">
                                            <div class="card-body">
                                                <div
                                                    v-b-toggle="
                                                        'probList' +
                                                            index +
                                                            ' probListBanner' +
                                                            index
                                                    "
                                                    class="d-flex align-items-start justify-content-between"
                                                >
                                                    <h6
                                                        class="card-title flex-grow lower-line text-truncate"
                                                    >
                                                        {{ $t('Shared.Problem') }}:
                                                        {{ item.problem.probDesc }}
                                                    </h6>
                                                </div>
                                                <b-collapse
                                                    :id="'probListBanner' + index"
                                                    class="small-info ml-2"
                                                    visible
                                                    ><small>{{
                                                        $t('Shared.cMsg')
                                                    }}</small></b-collapse
                                                >
                                                <b-collapse :id="'probList' + index">
                                                    <div class="flex-container">
                                                        <!--<div class="subtitleButtons">
                                                <div class="containerBoxTitle">                                          
                                                    <b-icon icon="pencil-fill" @click="EditProblem(item)" v-b-tooltip.hover.top="'Edit Problem'" scale=".5" font-scale="1.6" variant="light"></b-icon>                                          
                                                </div>
                                            </div>
                                            <h4 class="page-subtitle text-truncate">Problem</h4>-->
                                                        <MdTitle
                                                            v-bind:VisibleEdit="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:VisiblePrint="true"
                                                            @ClickPrint="PrintProblem(item)"
                                                            @ClickEdit="OpenModalWiley(item)"
                                                            class="shrinkMargin"
                                                            v-bind:Text="
                                                                $t('Shared.Problem')
                                                            "
                                                            v-bind:IconPrintDescription="
                                                                $t('treatmentplanList.proReview')
                                                            "
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleProblem'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.Problem'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.probDesc
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.Diagnosis'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b
                                                                        >{{
                                                                            item.problem
                                                                                .dsm5description
                                                                        }}
                                                                        - {{ item.problem.dsm5 }}</b
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'modalEditGoal.dIdentified'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.probDate
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.CreatedBy'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.userName
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.CreatedOn'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.dateTimeCreate
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <MdTitle
                                                            @ClickEdit="
                                                                OpenModalBehavioralWiley(item)
                                                            "
                                                            @ClickAddTPBlank="
                                                                OpenModalBlankBehavioralWiley(item)
                                                            "
                                                            v-bind:VisibleAddBlank="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:BlankDescription="
                                                                $t('treatmentplan.Behavioral')
                                                            "
                                                            v-bind:VisibleEdit="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:Text="
                                                                $t('treatmentplan.Behavioral')
                                                            "
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleBehavioral'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="col text-muted">
                                                                    <ul>
                                                                        <li
                                                                            v-for="(behavioral,
                                                                            behaindex) in item.problemDefinitions"
                                                                            :key="behaindex"
                                                                        >
                                                                            {{
                                                                                behavioral.definitionDescription
                                                                            }}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!--<div class="subtitleButtons">
                                                  <div class="containerBoxTitle">
                                                     
                                                  </div>
                                              </div>
                                              <h4 class="page-subtitle text-truncate">Goals</h4>-->

                                                        <MdTitle
                                                            @ClickAddTPBlank="
                                                                OpenModalGoalWiley(item)
                                                            "
                                                            v-bind:VisibleAddBlank="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:BlankDescription="
                                                                $t('modalAddGoal.goals')
                                                            "
                                                            v-bind:Text="$t('modalAddGoal.goals')"
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleGoal'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="text-muted p-item">
                                                                    <div
                                                                        v-for="(g,
                                                                        goalindex) in item.goals"
                                                                        :key="goalindex"
                                                                    >
                                                                        <!-- GOALS -->
                                                                        <!--<MdTitle v-bind:Text="'Goal ' +(goalindex+1)" v-bind:isSubtitle="true" v-bind:Name="'T_TitleGoals'"/>-->
                                                                        <div class="mb-2 ml-2">
                                                                            <b-row
                                                                                v-b-toggle="
                                                                                    'goal' +
                                                                                        index +
                                                                                        (goalindex +
                                                                                            1)
                                                                                "
                                                                            >
                                                                                <b-col>
                                                                                    <!-- Condicionar esto para mostrar estados específicos -->
                                                                                    <!-- Si el estado es "MET", eliminar la clase completeDraft -->
                                                                                    <span
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .status
                                                                                        "
                                                                                        class="chRstatusfinished completeDraft align-middle"
                                                                                        >{{
                                                                                            g.goal
                                                                                                .status
                                                                                        }}</span
                                                                                    >
                                                                                    <p
                                                                                        class="font-weight-bold ml-1"
                                                                                    >
                                                                                        <b-icon
                                                                                            class="when-closed"
                                                                                            font-scale="1"
                                                                                            variant="primary"
                                                                                            icon="caret-down-fill"
                                                                                        ></b-icon
                                                                                        ><b-icon
                                                                                            class="when-open"
                                                                                            font-scale="1"
                                                                                            variant="primary"
                                                                                            icon="caret-up-fill"
                                                                                        ></b-icon
                                                                                        >{{
                                                                                            $t(
                                                                                                'modalEditGoal.goal'
                                                                                            )
                                                                                        }}
                                                                                        {{
                                                                                            goalindex +
                                                                                                1
                                                                                        }}
                                                                                        {{
                                                                                            g.goal
                                                                                                .goalDesc
                                                                                        }}
                                                                                    </p>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </div>
                                                                        <b-collapse
                                                                            :id="
                                                                                'goal' +
                                                                                    index +
                                                                                    (goalindex + 1)
                                                                            "
                                                                            class="mb-3 ml-2"
                                                                        >
                                                                            <b-button-group
                                                                                class="ml-3 groupActions"
                                                                                v-if="
                                                                                    !isReadOnly &&
                                                                                        !ReadOnlyProp
                                                                                "
                                                                            >
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        OpenModalAddObjectiveWiley(
                                                                                            item,
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    title="Add objective"
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="plus-circle-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        OpenModalEditGoalWiley(
                                                                                            item,
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    title="Edit goal"
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="pencil-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        DeleteGoalWiley(
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    :title="
                                                                                        $t(
                                                                                            'modalEditProblem.DelGolaTT'
                                                                                        )
                                                                                    "
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="trash-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                            </b-button-group>

                                                                            <b-card
                                                                                bg-variant="light"
                                                                            >
                                                                                <b-row cols="3">
                                                                                    <b-col
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.dIdentified'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p
                                                                                            v-if="
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateSet
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateSet
                                                                                            }}
                                                                                        </p>
                                                                                        <p v-else>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateExp
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.eDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateExp
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.eDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateAchieve
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.aDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateAchieve
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.aDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .status
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.Status'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .status
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.Status'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .sysUser
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedBy'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .userName
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedBy'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateTimeCreate
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedOn'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateTimeCreate
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedOn'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                </b-row>
                                                                                <div
                                                                                    class="mb-2 ml-3"
                                                                                    v-for="(o,
                                                                                    oindex) in g.objectives"
                                                                                    :key="oindex"
                                                                                >
                                                                                    <b-row
                                                                                        v-b-toggle="
                                                                                            'obj' +
                                                                                                index +
                                                                                                (goalindex +
                                                                                                    1) +
                                                                                                (oindex +
                                                                                                    1)
                                                                                        "
                                                                                    >
                                                                                        <b-col>
                                                                                            <!-- Condicionar esto para mostrar estados específicos -->
                                                                                            <!-- Los posibles estados son: inprogress, met, unmet, revised, extended, deferred, reffered -->
                                                                                            <!-- Con las 2 clases sale azul, sin la 2da, sale verde -->
                                                                                            <span
                                                                                                v-if="
                                                                                                    o
                                                                                                        .objective
                                                                                                        .status
                                                                                                "
                                                                                                class="chRstatusfinished completeDraft"
                                                                                                >{{
                                                                                                    o
                                                                                                        .objective
                                                                                                        .status
                                                                                                }}</span
                                                                                            >
                                                                                            <p
                                                                                                class="mt-1"
                                                                                            >
                                                                                                <span
                                                                                                    class="font-weight-bold"
                                                                                                    ><b-icon
                                                                                                        class="when-closed"
                                                                                                        font-scale="1"
                                                                                                        variant="primary"
                                                                                                        icon="caret-down-fill"
                                                                                                    ></b-icon
                                                                                                    ><b-icon
                                                                                                        class="when-open"
                                                                                                        font-scale="1"
                                                                                                        variant="primary"
                                                                                                        icon="caret-up-fill"
                                                                                                    ></b-icon>
                                                                                                    {{
                                                                                                        $t(
                                                                                                            'modalAddObjective.objectives'
                                                                                                        )
                                                                                                    }}
                                                                                                    {{
                                                                                                        oindex +
                                                                                                            1
                                                                                                    }}</span
                                                                                                >:
                                                                                                {{
                                                                                                    o
                                                                                                        .objective
                                                                                                        .objDesc
                                                                                                }}
                                                                                            </p>
                                                                                        </b-col>
                                                                                    </b-row>

                                                                                    <b-collapse
                                                                                        :id="
                                                                                            'obj' +
                                                                                                index +
                                                                                                (goalindex +
                                                                                                    1) +
                                                                                                (oindex +
                                                                                                    1)
                                                                                        "
                                                                                        class="mb-3 mt-2 ml-2"
                                                                                    >
                                                                                        <b-button-group
                                                                                            class="ml-3 groupActions whiteBtn"
                                                                                            v-if="
                                                                                                !isReadOnly &&
                                                                                                    !ReadOnlyProp
                                                                                            "
                                                                                        >
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    OpenModalAddInterventionWiley(
                                                                                                        item,
                                                                                                        g,
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                :title="
                                                                                                    $t(
                                                                                                        'treatmentplanList.addInt'
                                                                                                    )
                                                                                                "
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="plus-circle-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    OpenModalEditObjectiveWiley(
                                                                                                        item,
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                title="Edit objective"
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="pencil-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    PrintObjective(
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                title="Objective Review"
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="printer-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    DeleteObjective(
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                :title="
                                                                                                    $t(
                                                                                                        'modalEditProblem.DelObjTT'
                                                                                                    )
                                                                                                "
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="trash-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                        </b-button-group>

                                                                                        <b-card
                                                                                            bg-variant="white"
                                                                                        >
                                                                                            <b-row
                                                                                                cols="3"
                                                                                            >
                                                                                                <!-- IMHO, la condición debería estar en el párrafo, que es lo que cambia -->
                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateSet
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.dIdentified'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateSet
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.dIdentified'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateExp
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.eDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateExp
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.eDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateAchieve
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.aDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateAchieve
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.aDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .status
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.Status'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .status
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.Status'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .sysUser
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedBy'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .userName
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedBy'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateTimeCreate
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedOn'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateTimeCreate
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedOn'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                            </b-row>
                                                                                        </b-card>
                                                                                    </b-collapse>

                                                                                    <div
                                                                                        class="mb-2 ml-2"
                                                                                        v-for="(i,
                                                                                        iindex) in o.interventions"
                                                                                        :key="
                                                                                            iindex
                                                                                        "
                                                                                    >
                                                                                        <b-row
                                                                                            v-b-toggle="
                                                                                                'int' +
                                                                                                    index +
                                                                                                    (goalindex +
                                                                                                        1) +
                                                                                                    (oindex +
                                                                                                        1) +
                                                                                                    (iindex +
                                                                                                        1)
                                                                                            "
                                                                                        >
                                                                                            <b-col>
                                                                                                <p
                                                                                                    class="mt-1"
                                                                                                >
                                                                                                    <span
                                                                                                        class="font-weight-bold"
                                                                                                        ><b-icon
                                                                                                            class="when-closed"
                                                                                                            font-scale="1"
                                                                                                            variant="primary"
                                                                                                            icon="caret-down-fill"
                                                                                                        ></b-icon
                                                                                                        ><b-icon
                                                                                                            class="when-open"
                                                                                                            font-scale="1"
                                                                                                            variant="primary"
                                                                                                            icon="caret-up-fill"
                                                                                                        ></b-icon>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Intervention'
                                                                                                            )
                                                                                                        }}
                                                                                                        {{
                                                                                                            iindex +
                                                                                                                1
                                                                                                        }}</span
                                                                                                    >:
                                                                                                    {{
                                                                                                        i.intDesc
                                                                                                    }}
                                                                                                </p>
                                                                                            </b-col>
                                                                                        </b-row>

                                                                                        <b-collapse
                                                                                            :id="
                                                                                                'int' +
                                                                                                    index +
                                                                                                    (goalindex +
                                                                                                        1) +
                                                                                                    (oindex +
                                                                                                        1) +
                                                                                                    (iindex +
                                                                                                        1)
                                                                                            "
                                                                                            class="mb-3 mt-2 ml-2"
                                                                                        >
                                                                                            <b-button-group
                                                                                                class="ml-3 groupActions whiteBtn"
                                                                                                v-if="
                                                                                                    !isReadOnly &&
                                                                                                        !ReadOnlyProp
                                                                                                "
                                                                                            >
                                                                                                <b-button
                                                                                                    v-on:click="
                                                                                                        OpenModalEditInterventionWiley(
                                                                                                            item,
                                                                                                            i
                                                                                                        )
                                                                                                    "
                                                                                                    v-b-tooltip.hover
                                                                                                    :title="
                                                                                                        $t(
                                                                                                            'treatmentplanList.editInt'
                                                                                                        )
                                                                                                    "
                                                                                                    size="sm"
                                                                                                    variant="light"
                                                                                                >
                                                                                                    <b-icon
                                                                                                        icon="pencil-fill"
                                                                                                        aria-hidden="true"
                                                                                                    ></b-icon>
                                                                                                </b-button>
                                                                                                <b-button
                                                                                                    v-on:click="
                                                                                                        DeleteIntervention(
                                                                                                            i
                                                                                                        )
                                                                                                    "
                                                                                                    v-b-tooltip.hover
                                                                                                    :title="
                                                                                                        $t(
                                                                                                            'modalEditProblem.DelIntTT'
                                                                                                        )
                                                                                                    "
                                                                                                    size="sm"
                                                                                                    variant="light"
                                                                                                >
                                                                                                    <b-icon
                                                                                                        icon="trash-fill"
                                                                                                        aria-hidden="true"
                                                                                                    ></b-icon>
                                                                                                </b-button>
                                                                                            </b-button-group>

                                                                                            <b-card
                                                                                                bg-variant="white"
                                                                                            >
                                                                                                <b-row
                                                                                                    cols="3"
                                                                                                >
                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.startDate
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'treatmentplanList.starOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.startDate
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'treatmentplanList.starOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.amount
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.AmountValCode'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noAmt
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.amount
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.AmountValCode'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.frequency
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Frequency'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noFrequency
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.frequency
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Frequency'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.duration
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Duration'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noDuration
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.duration
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Duration'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.therapistCode
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedBy'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.therapistName
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedBy'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.dateTimeCreate
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.dateTimeCreate
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                </b-row>
                                                                                            </b-card>
                                                                                            <b-card
                                                                                                bg-variant="white"
                                                                                                class="mt-2"
                                                                                                v-if="
                                                                                                    i
                                                                                                        .therapyNames
                                                                                                        .length >
                                                                                                        0
                                                                                                "
                                                                                            >
                                                                                                <b-row>
                                                                                                    <b-col
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'modalEditIntervention.Modalities'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <ul>
                                                                                                            <li
                                                                                                                v-for="(m,
                                                                                                                mindex) in i.therapyNames"
                                                                                                                :key="
                                                                                                                    mindex
                                                                                                                "
                                                                                                            >
                                                                                                                {{
                                                                                                                    m
                                                                                                                }}
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </b-col>
                                                                                                </b-row>
                                                                                            </b-card>
                                                                                        </b-collapse>
                                                                                    </div>
                                                                                </div>
                                                                            </b-card>
                                                                        </b-collapse>

                                                                        <!-- OBJECTIVES -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="VisibleSignature">
                    <div class="col-12">
                        <!-- div Container Boxs -->
                        <div class="IncidentContainerBox noNum">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="grid-margin stretch-card">
                                        <div class="card activeCard">
                                            <div class="card-body">
                                                <div
                                                    v-b-toggle="'signaList signaListBanner'"
                                                    class="d-flex align-items-start justify-content-between"
                                                >
                                                    <h6
                                                        class="card-title flex-grow lower-line text-truncate"
                                                    >
                                                        {{
                                                            $t('modalAddSignature.sign', {
                                                                label: ''
                                                            })
                                                        }}
                                                    </h6>
                                                </div>
                                                <div class="pull-right containerBoxTitle ml-5">
                                                    <b-icon
                                                        icon="plus-circle-fill"
                                                        @click="AddSignatureWiley"
                                                        v-b-tooltip.hover.top="
                                                            $t('modalAddSignature.sign', {
                                                                label: $t('Shared.Add')
                                                            })
                                                        "
                                                        scale=".5"
                                                        font-scale="1.6"
                                                        variant="light"
                                                        v-if="!isReadOnly && !ReadOnlyProp"
                                                    ></b-icon>
                                                </div>
                                                <b-collapse
                                                    id="signaListBanner"
                                                    class="small-info ml-2"
                                                    visible
                                                    ><small>{{
                                                        $t('treatmentplanList.cliTiteltext')
                                                    }}</small></b-collapse
                                                >
                                                <b-collapse id="signaList">
                                                    <div
                                                        v-for="(s,
                                                        sindex) in TreatmentPlan.signatures"
                                                        :key="sindex"
                                                    >
                                                        <b-button-group
                                                            class="ml-3 groupActions"
                                                            v-if="!isReadOnly && !ReadOnlyProp"
                                                        >
                                                            <b-button
                                                                v-if="
                                                                    TreatmentPlan.signatures
                                                                        .length -
                                                                        1 ==
                                                                        sindex
                                                                "
                                                                v-on:click="AddSignatureWiley"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.Add')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="plus-circle-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <b-button
                                                                v-if="
                                                                    TreatmentPlan.signatures
                                                                        .length > 0
                                                                "
                                                                v-on:click="EditSignatureWiley(s)"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.Edit')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="pencil-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <b-button
                                                                v-on:click="DeleteSignature(s)"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.TitleDelete')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="trash-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <!--<b-button v-on:click="DeleteGoal(g)" v-b-tooltip.hover title="Delete signature" size="sm" variant="light">
                                                        <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                                      </b-button>-->
                                                        </b-button-group>
                                                        <b-card bg-variant="light" class="mb-3">
                                                            <div>
                                                                <b-row>
                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'Shared.Provider'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b v-if="s.therapistName">{{
                                                                            s.therapistName
                                                                        }}</b>
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nProvider'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.therapistName"
                                                                            >{{
                                                                                s.signedDate
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                s.signedDate ===
                                                                                    null &&
                                                                                    !s.isSigned
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplan.NoSigned'
                                                                                )
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'treatmentplanList.CoProvider'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b
                                                                            v-if="
                                                                                s.coTherapistName &&
                                                                                    s.coTherapistName.trim() !==
                                                                                        ''
                                                                            "
                                                                            >{{
                                                                                s.coTherapistName
                                                                            }}</b
                                                                        >
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nCoProSign'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.coTherapistName"
                                                                            >{{
                                                                                s.coSignedDate
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                s.coSignedDate ===
                                                                                    null &&
                                                                                    !s.isCosigned
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplan.NoSigned'
                                                                                )
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $tc('Shared.Patient')
                                                                        }}</small
                                                                        ><br />
                                                                        <b
                                                                            v-if="
                                                                                s.patientName !==
                                                                                    '' &&
                                                                                    s.refuseSigned ===
                                                                                        false
                                                                            "
                                                                            >{{ s.patientName }}</b
                                                                        >
                                                                        <b v-if="s.refuseSigned">{{
                                                                            $t(
                                                                                'modalAddSignature.pRefused'
                                                                            )
                                                                        }}</b>
                                                                        <b
                                                                            v-if="
                                                                                s.refuseSigned ===
                                                                                    false &&
                                                                                    s.patientName ===
                                                                                        ''
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplanList.nPaSign'
                                                                                )
                                                                            }}</b
                                                                        >

                                                                        <br />
                                                                        <span
                                                                            v-if="
                                                                                s.patientSignedDate
                                                                            "
                                                                            >{{
                                                                                s.patientSignedDate
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'modalAddSignature.guardian'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b v-if="s.guardianName">{{
                                                                            s.guardianName
                                                                        }}</b>
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nGaSign'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.guardianName"
                                                                            >{{
                                                                                s.guardianSignedDate
                                                                            }}</span
                                                                        >
                                                                    </div>
                                                                </b-row>
                                                            </div>
                                                        </b-card>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <wyModalEditSignature
                    @ModalTreatmentPlanSignatureCANCEL="OnReturnSignatureCancelWiley($event)"
                    v-bind:UseInModal="true"
                    v-bind:NotesId="NotesId"
                    v-bind:PatientCode="this.PatientCode"
                    v-bind:Signatures="TreatmentPlan.signatures"
                    v-if="showModalSignatureWiley"
                    v-bind:ModalId="'modalIdEditSignature'"
                    v-bind:TitleWindow="$t('modalAddSignature.sign', { label: $t('Shared.Edit') })"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:SignatureEdit="SignatureEdit"
                />

                <wyModalEditTPProblem
                    @ModalTPEditProblemCANCEL="OnEditTPProblemCancelWiley($event)"
                    v-if="VisibleEditTPProblemWiley"
                    v-bind:ModalId="'modalIdEditTPProblem'"
                    v-bind:TitleWindow="$t('treatmentplanList.editP')"
                    v-bind:ProbDesc="ProbDesc"
                    v-bind:DiagDesc="DiagDesc"
                    v-bind:DiagCode="DiagCode"
                    v-bind:ProblemDateIdentified="ProblemDateIdentified"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <wyModalEditTPBehavioral
                    v-if="VisibleEditTPBehavioralWiley"
                    v-bind:ModalId="'modalIdEditBehaviral'"
                    v-bind:BehavioralsProp="BehavioralsModal"
                    v-bind:TitleWindow="$t('treatmentplanList.editB')"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:ProblemRecId="ProblemRecId"
                    @ModalTPEditBehavioralCANCEL="ModalTPEditBehavioralCANCELWiley"
                />

                <wyModalBlankTPBehavioral
                    @ModalTPBlankBehavioral="ModalTPBlankBehavioralCANCELWiley"
                    v-if="VisibleBlankTPBehavioralWiley"
                    v-bind:ModalId="'modalIdTPBlankBehavioral'"
                    v-bind:TitleWindow="$t('treatmentplanList.addB')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <wyModalAddGoal
                    @ModalTPGoal="ModalTPGoalCANCELWiley"
                    v-if="VisibleAddGoalsWiley"
                    v-bind:ModalId="'modalIdAddGoals'"
                    v-bind:TitleWindow="$t('treatmentplanList.addG')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <wyModalAddObjective
                    @ModalTPObjective="ModalTPObjectiveCANCELWiley"
                    v-if="VisibleAddObjetiveWiley"
                    v-bind:ModalId="'modalIdAddObjective'"
                    v-bind:TitleWindow="$t('treatmentplanList.addObj')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    v-bind:GoalListObj="GoalListObj"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalRecId="GoalRecId"
                />

                <wyModalEditGoal
                    @ModalTPEditGoal="ModalTPEditGoalWiley"
                    v-if="VisibleEditGoalWiley"
                    v-bind:ModalId="'modalIdEditGoal'"
                    v-bind:TitleWindow="$t('treatmentplanList.editG')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalEdit="this.GoalEdit"
                />

                <wyModalAddIntervention
                    @ModalTPAddIntervention="ModalTPAddInterventionWiley"
                    v-if="VisibleAddInterventionWiley"
                    v-bind:ModalId="'modalIdAddIntervention'"
                    v-bind:TitleWindow="$t('treatmentplanList.addInt')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalListObj="GoalListObj"
                    v-bind:ObjectiveListObj="ObjectiveListObj"
                    v-bind:GoalRecId="GoalRecId"
                    v-bind:ObjRecId="ObjRecId"
                />

                <wyModalEditObjective
                    @ModalTPEditObjective="ModalTPEditObjectiveWiley"
                    v-if="VisibleEditObjectiveWiley"
                    v-bind:ModalId="'modalIdEditObjective'"
                    v-bind:TitleWindow="$t('treatmentplanList.editObj')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:ObjectiveEdit="this.ObjectiveEdit"
                />

                <wyModalEditIntervention
                    @ModalTPEditIntervention="ModalTPEditInterventionWiley"
                    v-if="VisibleEditInterventionWiley"
                    v-bind:ModalId="'modalIdEditIntervention'"
                    v-bind:TitleWindow="$t('treatmentplanList.editInt')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:IntEditModal="this.InterventionEdit"
                />

                <wyModalAddSignature
                    @ModalTPAddSignature="ModalTPAddSignatureWiley"
                    v-if="VisibleAddSignatureWiley"
                    v-bind:UseInModal="true"
                    v-bind:NotesId="NotesId"
                    v-bind:PatientCode="this.PatientCode"
                    v-bind:ModalId="'modalIdAddSignature'"
                    v-bind:TitleWindow="$t('modalAddSignature.sign', { label: $t('Shared.Add') })"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <TreatmentPlanRep
                    v-if="isReportVisible"
                    :closeWindow="closeParamRepWindow"
                    :patientCode="parameter.AdmissionId"
                    :recNo="parameter.AdmissionId"
                    :notesId="NotesId"
                    :version="this.VersionModel.code"
                />
                <ObjectiveReviewRep
                    v-if="isObjectiveRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="this.RegistrationInfo.recordId"
                    :objRecId="ObjRecId"
                />
                <ProblemReviewRep
                    v-if="isProblemRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="this.RegistrationInfo.recordId"
                    :problemRecId="ProblemRecId"
                />
                <TreatmentPlanProblemRep
                    v-if="isTreatmentPlanProblemRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="parameter.AdmissionId"
                    :notesId="NotesId"
                    :probRecId="ProblemRecId"
                    :version="this.VersionModel.code"
                />
            </div>

            <!-- ----------------------------------------------------------------------------------------------------------------------------- -->
            <!-- ----------------------------------------------------------------------------------------------------------------------------- -->
            <!-- ----------------------------------------------------------------------------------------------------------------------------- -->

            <div
                v-show="TreatmentPlanType === 'TFRMTREATMENTPLANNOTES'"
                id="ContainerTreatmentPlanListMedez"
            >
                <div class="row">
                    <div class="col-12">
                        <MdTitleRegInfo
                            v-if="VisibleBar"
                            v-bind:RegistrationInfo="RegistrationInfo"
                            v-bind:titlePrefix="$t('Shared.treatmentplan')"
                            v-bind:IsClinical="true"
                            v-bind:titleRef="'titleElementTreatmentplanList'"
                            v-bind:patientCode="this.$route.params.id"
                        >
                        </MdTitleRegInfo>

                        <div
                            class="alert alert-fill-warning d-flex align-items-center m-3"
                            role="alert"
                            v-if="isReadOnly"
                        >
                            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                            <div class="flex-grow-1">
                                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <MdButton
                                    v-bind:Label="$t('treatmentplan.AddProblem')"
                                    v-bind:ClassProp="
                                        this.isReadOnly
                                            ? 'btn btn-primary my-3 btn-block'
                                            : 'btn btn-primary my-3 btn-block btn-login'
                                    "
                                    v-bind:IconClass="'ti-plus pr-1'"
                                    v-on:click="AddProblemMedez"
                                    v-bind:isReadOnly="this.isReadOnly || ReadOnlyProp"
                                    v-bind:Name="'btn_add_problem'"
                                >
                                </MdButton>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-4">
                                <div
                                    class="textlabel"
                                    :data-label="this.$t('Shared.SearchElements')"
                                >
                                    <div class="input-group" dir="ltr">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="parameter.SearchCriteria"
                                            :dir="dirInput"
                                            @keyup.enter="SearchProblems"
                                            :placeholder="$t('treatmentplanList.sProbDes')"
                                        />

                                        <div class="input-group-append">
                                            <MdButton
                                                v-bind:Name="'btnsearchinput'"
                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                v-on:click="SearchProblems"
                                            >
                                            </MdButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <MdSelect
                                    v-bind:Label="$t('MdNote.Versions')"
                                    v-bind:Options="VersionList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:AllowEmpty="false"
                                    v-bind:NoEmitChange="true"
                                    v-bind:Model="VersionModel"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownVersions"
                                />
                            </div>
                        </div>

                        <div
                            class="alert alert-fill-warning d-flex align-items-center m-3"
                            role="alert"
                            v-if="this.VersionModel.code > 0"
                        >
                            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                            <div class="flex-grow-1">
                                <span>{{ $t('MdNote.pNoteVersionMsg') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div v-if="VisibleNoRecords" class="empty-row-banner m-3">
                            <div class="text-center my-2">
                                {{ $t('treatmentplanList.nProbYet') }}
                            </div>
                        </div>
                        <div v-if="VisibleNoRecordsWithFilter" class="empty-row-banner m-3">
                            <div class="text-center my-2">
                                {{ $t('treatmentplanList.nProbMa') }}
                            </div>
                        </div>

                        <div
                            v-for="(item, index) in this.TreatmentPlan.problems"
                            :key="index"
                            class="IncidentContainerBox"
                        >
                            <div class="pull-right containerBoxTitle ml-5">
                                <!-- <b-icon icon="pencil-fill" @click="EditProblem(item)" v-b-tooltip.hover.top="'Edit Problem'" scale=".5" font-scale="1.6" variant="light"></b-icon>-->
                                <!--<b-icon icon="printer-fill" @click="PrintOnlyProblem(item)" v-b-tooltip.hover.top="$t('treatmentplanList.printProb')"
              scale=".5" font-scale="1.6" variant="light"></b-icon>-->
                                <span
                                    @click="PrintOnlyProblem(item)"
                                    v-b-tooltip.hover.top="$t('treatmentplanList.printProb')"
                                    class="tableBTNtext ikon med-print mx-4"
                                ></span>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="grid-margin stretch-card">
                                        <div class="card activeCard">
                                            <div class="card-body">
                                                <div
                                                    v-b-toggle="
                                                        'probList' +
                                                            index +
                                                            ' probListBanner' +
                                                            index
                                                    "
                                                    class="d-flex align-items-start justify-content-between"
                                                >
                                                    <h6
                                                        class="card-title flex-grow lower-line text-truncate"
                                                    >
                                                        {{ $t('Shared.Problem') }}:
                                                        {{ item.problem.probDesc }}
                                                    </h6>
                                                </div>
                                                <b-collapse
                                                    :id="'probListBanner' + index"
                                                    class="small-info ml-2"
                                                    visible
                                                    ><small>{{
                                                        $t('Shared.cMsg')
                                                    }}</small></b-collapse
                                                >
                                                <b-collapse :id="'probList' + index">
                                                    <div class="flex-container">
                                                        <!--<div class="subtitleButtons">
                                      <div class="containerBoxTitle">                                          
                                          <b-icon icon="pencil-fill" @click="EditProblem(item)" v-b-tooltip.hover.top="'Edit Problem'" scale=".5" font-scale="1.6" variant="light"></b-icon>                                          
                                      </div>
                                  </div>
                                  <h4 class="page-subtitle text-truncate">Problem</h4>-->
                                                        <MdTitle
                                                            v-bind:VisibleEdit="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:VisiblePrint="true"
                                                            @ClickPrint="PrintProblem(item)"
                                                            @ClickEdit="OpenModalMedez(item)"
                                                            class="shrinkMargin"
                                                            v-bind:Text="
                                                                $t('Shared.Problem')
                                                            "
                                                            v-bind:IconPrintDescription="
                                                                $t('treatmentplanList.proReview')
                                                            "
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleProblem'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-3">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.Problem'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.probDesc
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'modalEditGoal.dIdentified'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.probDate
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.CreatedBy'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.userName
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div
                                                                    class="float-left col text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t(
                                                                            'Shared.CreatedOn'
                                                                        )
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        item.problem.dateTimeCreate
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <MdTitle
                                                            @ClickEdit="
                                                                OpenModalBehavioralMedez(item)
                                                            "
                                                            @ClickAddTPBlank="
                                                                OpenModalBlankBehavioralMedez(item)
                                                            "
                                                            v-bind:VisibleAddBlank="false"
                                                            v-bind:BlankDescription="
                                                                $t(
                                                                    'Shared.PsychosocialEnvironmental'
                                                                )
                                                            "
                                                            v-bind:VisibleEdit="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:Text="
                                                                $t(
                                                                    'Shared.PsychosocialEnvironmental'
                                                                )
                                                            "
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleBehavioral'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div
                                                                    class="wizObjectives"
                                                                    v-for="(agg,
                                                                    aggindex) in item.problemAggregates"
                                                                    :key="aggindex"
                                                                >
                                                                    <b-icon
                                                                        icon="check"
                                                                        class="wizardCheckObj"
                                                                    ></b-icon>
                                                                    <span> {{ agg.aggName }} </span>
                                                                    <div class="ml-3 mt-2">
                                                                        <ul>
                                                                            <li
                                                                                v-for="(it,
                                                                                indexit) in agg.list"
                                                                                :key="indexit"
                                                                            >
                                                                                {{ it.name }}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!--<div class="subtitleButtons">
                                        <div class="containerBoxTitle">
                                           
                                        </div>
                                    </div>
                                    <h4 class="page-subtitle text-truncate">Goals</h4>-->

                                                        <MdTitle
                                                            @ClickAddTPBlank="
                                                                OpenModalGoalMedez(item)
                                                            "
                                                            v-bind:VisibleAddBlank="
                                                                !isReadOnly && !ReadOnlyProp
                                                            "
                                                            v-bind:BlankDescription="
                                                                $t('modalAddGoal.goals')
                                                            "
                                                            v-bind:Text="$t('modalAddGoal.goals')"
                                                            v-bind:isSubtitle="true"
                                                            v-bind:Name="'T_TitleGoal'"
                                                        />

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="text-muted p-item">
                                                                    <div
                                                                        v-for="(g,
                                                                        goalindex) in item.goals"
                                                                        :key="goalindex"
                                                                    >
                                                                        <!-- GOALS -->
                                                                        <!--<MdTitle v-bind:Text="'Goal ' +(goalindex+1)" v-bind:isSubtitle="true" v-bind:Name="'T_TitleGoals'"/>-->
                                                                        <div class="mb-2 ml-2">
                                                                            <b-row
                                                                                v-b-toggle="
                                                                                    'goal' +
                                                                                        index +
                                                                                        (goalindex +
                                                                                            1)
                                                                                "
                                                                            >
                                                                                <b-col>
                                                                                    <!-- Condicionar esto para mostrar estados específicos -->
                                                                                    <!-- Si el estado es "MET", eliminar la clase completeDraft -->
                                                                                    <span
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .status
                                                                                        "
                                                                                        class="chRstatusfinished completeDraft align-middle"
                                                                                        >{{
                                                                                            g.goal
                                                                                                .status
                                                                                        }}</span
                                                                                    >
                                                                                    <p
                                                                                        class="font-weight-bold ml-1"
                                                                                    >
                                                                                        <b-icon
                                                                                            class="when-closed"
                                                                                            font-scale="1"
                                                                                            variant="primary"
                                                                                            icon="caret-down-fill"
                                                                                        ></b-icon
                                                                                        ><b-icon
                                                                                            class="when-open"
                                                                                            font-scale="1"
                                                                                            variant="primary"
                                                                                            icon="caret-up-fill"
                                                                                        ></b-icon
                                                                                        >{{
                                                                                            $t(
                                                                                                'modalEditGoal.goal'
                                                                                            )
                                                                                        }}
                                                                                        {{
                                                                                            goalindex +
                                                                                                1
                                                                                        }}
                                                                                        {{
                                                                                            g.goal
                                                                                                .goalDesc
                                                                                        }}
                                                                                    </p>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </div>
                                                                        <b-collapse
                                                                            :id="
                                                                                'goal' +
                                                                                    index +
                                                                                    (goalindex + 1)
                                                                            "
                                                                            class="mb-3 ml-2"
                                                                        >
                                                                            <b-button-group
                                                                                class="ml-3 groupActions"
                                                                                v-if="
                                                                                    !isReadOnly &&
                                                                                        !ReadOnlyProp
                                                                                "
                                                                            >
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        OpenModalAddObjectiveMedez(
                                                                                            item,
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    title="Add objective"
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="plus-circle-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        OpenModalEditGoalMedez(
                                                                                            item,
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    title="Edit goal"
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="pencil-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                                <b-button
                                                                                    v-on:click="
                                                                                        DeleteGoal(
                                                                                            g
                                                                                        )
                                                                                    "
                                                                                    v-b-tooltip.hover
                                                                                    :title="
                                                                                        $t(
                                                                                            'modalEditProblem.DelGolaTT'
                                                                                        )
                                                                                    "
                                                                                    size="sm"
                                                                                    variant="light"
                                                                                >
                                                                                    <b-icon
                                                                                        icon="trash-fill"
                                                                                        aria-hidden="true"
                                                                                    ></b-icon>
                                                                                </b-button>
                                                                            </b-button-group>

                                                                            <b-card
                                                                                bg-variant="light"
                                                                            >
                                                                                <b-row cols="3">
                                                                                    <b-col
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.dIdentified'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p
                                                                                            v-if="
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateSet
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateSet
                                                                                            }}
                                                                                        </p>
                                                                                        <p v-else>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateExp
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.eDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateExp
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.eDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateAchieve
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.aDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateAchieve
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'modalEditGoal.aDate'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .status
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.Status'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .status
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.Status'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .sysUser
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedBy'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .userName
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedBy'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>

                                                                                    <b-col
                                                                                        v-if="
                                                                                            g.goal
                                                                                                .dateTimeCreate
                                                                                        "
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedOn'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                g
                                                                                                    .goal
                                                                                                    .dateTimeCreate
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                    <b-col v-else
                                                                                        ><small>{{
                                                                                            $t(
                                                                                                'Shared.CreatedOn'
                                                                                            )
                                                                                        }}</small
                                                                                        ><br />
                                                                                        <p>
                                                                                            {{
                                                                                                $t(
                                                                                                    'Shared.Notdefined'
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </b-col>
                                                                                </b-row>
                                                                                <div
                                                                                    class="mb-2 ml-3"
                                                                                    v-for="(o,
                                                                                    oindex) in g.objectives"
                                                                                    :key="oindex"
                                                                                >
                                                                                    <b-row
                                                                                        v-b-toggle="
                                                                                            'obj' +
                                                                                                index +
                                                                                                (goalindex +
                                                                                                    1) +
                                                                                                (oindex +
                                                                                                    1)
                                                                                        "
                                                                                    >
                                                                                        <b-col>
                                                                                            <!-- Condicionar esto para mostrar estados específicos -->
                                                                                            <!-- Los posibles estados son: inprogress, met, unmet, revised, extended, deferred, reffered -->
                                                                                            <!-- Con las 2 clases sale azul, sin la 2da, sale verde -->
                                                                                            <span
                                                                                                v-if="
                                                                                                    o
                                                                                                        .objective
                                                                                                        .status
                                                                                                "
                                                                                                class="chRstatusfinished completeDraft"
                                                                                                >{{
                                                                                                    o
                                                                                                        .objective
                                                                                                        .status
                                                                                                }}</span
                                                                                            >
                                                                                            <p
                                                                                                class="mt-1"
                                                                                            >
                                                                                                <span
                                                                                                    class="font-weight-bold"
                                                                                                    ><b-icon
                                                                                                        class="when-closed"
                                                                                                        font-scale="1"
                                                                                                        variant="primary"
                                                                                                        icon="caret-down-fill"
                                                                                                    ></b-icon
                                                                                                    ><b-icon
                                                                                                        class="when-open"
                                                                                                        font-scale="1"
                                                                                                        variant="primary"
                                                                                                        icon="caret-up-fill"
                                                                                                    ></b-icon>
                                                                                                    {{
                                                                                                        $t(
                                                                                                            'modalAddObjective.objectives'
                                                                                                        )
                                                                                                    }}
                                                                                                    {{
                                                                                                        oindex +
                                                                                                            1
                                                                                                    }}</span
                                                                                                >:
                                                                                                {{
                                                                                                    o
                                                                                                        .objective
                                                                                                        .objDesc
                                                                                                }}
                                                                                            </p>
                                                                                        </b-col>
                                                                                    </b-row>

                                                                                    <b-collapse
                                                                                        :id="
                                                                                            'obj' +
                                                                                                index +
                                                                                                (goalindex +
                                                                                                    1) +
                                                                                                (oindex +
                                                                                                    1)
                                                                                        "
                                                                                        class="mb-3 mt-2 ml-2"
                                                                                    >
                                                                                        <b-button-group
                                                                                            class="ml-3 groupActions whiteBtn"
                                                                                            v-if="
                                                                                                !isReadOnly &&
                                                                                                    !ReadOnlyProp
                                                                                            "
                                                                                        >
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    OpenModalAddInterventionMedez(
                                                                                                        item,
                                                                                                        g,
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                :title="
                                                                                                    $t(
                                                                                                        'treatmentplanList.addInt'
                                                                                                    )
                                                                                                "
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="plus-circle-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    OpenModalEditObjectiveMedez(
                                                                                                        item,
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                title="Edit objective"
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="pencil-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    PrintObjective(
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                title="Objective Review"
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="printer-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                            <b-button
                                                                                                v-on:click="
                                                                                                    DeleteObjective(
                                                                                                        o
                                                                                                    )
                                                                                                "
                                                                                                v-b-tooltip.hover
                                                                                                :title="
                                                                                                    $t(
                                                                                                        'modalEditProblem.DelObjTT'
                                                                                                    )
                                                                                                "
                                                                                                size="sm"
                                                                                                variant="light"
                                                                                            >
                                                                                                <b-icon
                                                                                                    icon="trash-fill"
                                                                                                    aria-hidden="true"
                                                                                                ></b-icon>
                                                                                            </b-button>
                                                                                        </b-button-group>

                                                                                        <b-card
                                                                                            bg-variant="white"
                                                                                        >
                                                                                            <b-row
                                                                                                cols="3"
                                                                                            >
                                                                                                <!-- IMHO, la condición debería estar en el párrafo, que es lo que cambia -->
                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateSet
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.dIdentified'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateSet
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.dIdentified'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateExp
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.eDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateExp
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.eDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateAchieve
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.aDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateAchieve
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'modalEditGoal.aDate'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .status
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.Status'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .status
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.Status'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .sysUser
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedBy'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .userName
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedBy'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>

                                                                                                <b-col
                                                                                                    v-if="
                                                                                                        o
                                                                                                            .objective
                                                                                                            .dateTimeCreate
                                                                                                    "
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedOn'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            o
                                                                                                                .objective
                                                                                                                .dateTimeCreate
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                                <b-col
                                                                                                    v-else
                                                                                                    ><small
                                                                                                        >{{
                                                                                                            $t(
                                                                                                                'Shared.CreatedOn'
                                                                                                            )
                                                                                                        }}</small
                                                                                                    ><br />
                                                                                                    <p>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Notdefined'
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
                                                                                                </b-col>
                                                                                            </b-row>
                                                                                        </b-card>
                                                                                    </b-collapse>

                                                                                    <div
                                                                                        class="mb-2 ml-2"
                                                                                        v-for="(i,
                                                                                        iindex) in o.interventions"
                                                                                        :key="
                                                                                            iindex
                                                                                        "
                                                                                    >
                                                                                        <b-row
                                                                                            v-b-toggle="
                                                                                                'int' +
                                                                                                    index +
                                                                                                    (goalindex +
                                                                                                        1) +
                                                                                                    (oindex +
                                                                                                        1) +
                                                                                                    (iindex +
                                                                                                        1)
                                                                                            "
                                                                                        >
                                                                                            <b-col>
                                                                                                <p
                                                                                                    class="mt-1"
                                                                                                >
                                                                                                    <span
                                                                                                        class="font-weight-bold"
                                                                                                        ><b-icon
                                                                                                            class="when-closed"
                                                                                                            font-scale="1"
                                                                                                            variant="primary"
                                                                                                            icon="caret-down-fill"
                                                                                                        ></b-icon
                                                                                                        ><b-icon
                                                                                                            class="when-open"
                                                                                                            font-scale="1"
                                                                                                            variant="primary"
                                                                                                            icon="caret-up-fill"
                                                                                                        ></b-icon>
                                                                                                        {{
                                                                                                            $t(
                                                                                                                'Shared.Intervention'
                                                                                                            )
                                                                                                        }}
                                                                                                        {{
                                                                                                            iindex +
                                                                                                                1
                                                                                                        }}</span
                                                                                                    >:
                                                                                                    {{
                                                                                                        i.intDesc
                                                                                                    }}
                                                                                                </p>
                                                                                            </b-col>
                                                                                        </b-row>

                                                                                        <b-collapse
                                                                                            :id="
                                                                                                'int' +
                                                                                                    index +
                                                                                                    (goalindex +
                                                                                                        1) +
                                                                                                    (oindex +
                                                                                                        1) +
                                                                                                    (iindex +
                                                                                                        1)
                                                                                            "
                                                                                            class="mb-3 mt-2 ml-2"
                                                                                        >
                                                                                            <b-button-group
                                                                                                class="ml-3 groupActions whiteBtn"
                                                                                                v-if="
                                                                                                    !isReadOnly &&
                                                                                                        !ReadOnlyProp
                                                                                                "
                                                                                            >
                                                                                                <b-button
                                                                                                    v-on:click="
                                                                                                        OpenModalEditInterventionMedez(
                                                                                                            item,
                                                                                                            i
                                                                                                        )
                                                                                                    "
                                                                                                    v-b-tooltip.hover
                                                                                                    :title="
                                                                                                        $t(
                                                                                                            'treatmentplanList.editInt'
                                                                                                        )
                                                                                                    "
                                                                                                    size="sm"
                                                                                                    variant="light"
                                                                                                >
                                                                                                    <b-icon
                                                                                                        icon="pencil-fill"
                                                                                                        aria-hidden="true"
                                                                                                    ></b-icon>
                                                                                                </b-button>
                                                                                                <b-button
                                                                                                    v-on:click="
                                                                                                        DeleteIntervention(
                                                                                                            i
                                                                                                        )
                                                                                                    "
                                                                                                    v-b-tooltip.hover
                                                                                                    :title="
                                                                                                        $t(
                                                                                                            'modalEditProblem.DelIntTT'
                                                                                                        )
                                                                                                    "
                                                                                                    size="sm"
                                                                                                    variant="light"
                                                                                                >
                                                                                                    <b-icon
                                                                                                        icon="trash-fill"
                                                                                                        aria-hidden="true"
                                                                                                    ></b-icon>
                                                                                                </b-button>
                                                                                            </b-button-group>

                                                                                            <b-card
                                                                                                bg-variant="white"
                                                                                            >
                                                                                                <b-row
                                                                                                    cols="3"
                                                                                                >
                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.startDate
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'treatmentplanList.starOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.startDate
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'treatmentplanList.starOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.amount
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.AmountValCode'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noAmt
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.amount
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.AmountValCode'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.frequency
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Frequency'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noFrequency
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.frequency
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Frequency'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.duration
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Duration'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.noDuration
                                                                                                            }}
                                                                                                            {{
                                                                                                                i.duration
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.Duration'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.therapistCode
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedBy'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.therapistName
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedBy'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>

                                                                                                    <b-col
                                                                                                        v-if="
                                                                                                            i.dateTimeCreate
                                                                                                        "
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                i.dateTimeCreate
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                    <b-col
                                                                                                        v-else
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'Shared.CreatedOn'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <p>
                                                                                                            {{
                                                                                                                $t(
                                                                                                                    'Shared.Notdefined'
                                                                                                                )
                                                                                                            }}
                                                                                                        </p>
                                                                                                    </b-col>
                                                                                                </b-row>
                                                                                            </b-card>
                                                                                            <b-card
                                                                                                bg-variant="white"
                                                                                                class="mt-2"
                                                                                                v-if="
                                                                                                    i
                                                                                                        .therapyNames
                                                                                                        .length >
                                                                                                        0
                                                                                                "
                                                                                            >
                                                                                                <b-row>
                                                                                                    <b-col
                                                                                                        ><small
                                                                                                            >{{
                                                                                                                $t(
                                                                                                                    'modalEditIntervention.Modalities'
                                                                                                                )
                                                                                                            }}</small
                                                                                                        ><br />
                                                                                                        <ul>
                                                                                                            <li
                                                                                                                v-for="(m,
                                                                                                                mindex) in i.therapyNames"
                                                                                                                :key="
                                                                                                                    mindex
                                                                                                                "
                                                                                                            >
                                                                                                                {{
                                                                                                                    m
                                                                                                                }}
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </b-col>
                                                                                                </b-row>
                                                                                            </b-card>
                                                                                        </b-collapse>
                                                                                    </div>
                                                                                </div>
                                                                            </b-card>
                                                                        </b-collapse>

                                                                        <!-- OBJECTIVES -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="VisibleSignature">
                    <div class="col-12">
                        <!-- div Container Boxs -->
                        <div class="IncidentContainerBox noNum">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="grid-margin stretch-card">
                                        <div class="card activeCard">
                                            <div class="card-body">
                                                <div
                                                    v-b-toggle="'signaList signaListBanner'"
                                                    class="d-flex align-items-start justify-content-between"
                                                >
                                                    <h6
                                                        class="card-title flex-grow lower-line text-truncate"
                                                    >
                                                        {{
                                                            $t('modalAddSignature.sign', {
                                                                label: ''
                                                            })
                                                        }}
                                                    </h6>
                                                </div>
                                                <div class="pull-right containerBoxTitle ml-5">
                                                    <!-- <b-icon icon="plus-circle-fill" @click="AddSignature" v-b-tooltip.hover.top="$t('modalAddSignature.sign', {'label': $t('Shared.Add')})"
                        scale=".5" font-scale="1.6" variant="light" v-if="!isReadOnly && !ReadOnlyProp"></b-icon>-->

                                                    <span
                                                        @click="AddSignatureMedez"
                                                        v-b-tooltip.hover.top="
                                                            $t('modalAddSignature.sign', {
                                                                label: $t('Shared.Add')
                                                            })
                                                        "
                                                        class="tableBTNtext ikon med-plus mx-4"
                                                    >
                                                    </span>
                                                </div>
                                                <b-collapse
                                                    id="signaListBanner"
                                                    class="small-info ml-2"
                                                    visible
                                                    ><small>{{
                                                        $t('treatmentplanList.cliTiteltext')
                                                    }}</small></b-collapse
                                                >
                                                <b-collapse id="signaList">
                                                    <div
                                                        v-for="(s,
                                                        sindex) in TreatmentPlan.signatures"
                                                        :key="sindex"
                                                    >
                                                        <b-button-group
                                                            class="ml-3 groupActions"
                                                            v-if="!isReadOnly && !ReadOnlyProp"
                                                        >
                                                            <b-button
                                                                v-if="
                                                                    TreatmentPlan.signatures
                                                                        .length -
                                                                        1 ==
                                                                        sindex
                                                                "
                                                                v-on:click="AddSignatureMedez"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.Add')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="plus-circle-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <b-button
                                                                v-if="
                                                                    TreatmentPlan.signatures
                                                                        .length > 0
                                                                "
                                                                v-on:click="EditSignatureMedez(s)"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.Edit')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="pencil-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <b-button
                                                                v-on:click="DeleteSignature(s)"
                                                                v-b-tooltip.hover
                                                                :title="
                                                                    $t('modalAddSignature.sign', {
                                                                        label: $t('Shared.TitleDelete')
                                                                    })
                                                                "
                                                                size="sm"
                                                                variant="light"
                                                            >
                                                                <b-icon
                                                                    icon="trash-fill"
                                                                    aria-hidden="true"
                                                                ></b-icon>
                                                            </b-button>
                                                            <!--<b-button v-on:click="DeleteGoal(g)" v-b-tooltip.hover title="Delete signature" size="sm" variant="light">
                                              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>-->
                                                        </b-button-group>
                                                        <b-card bg-variant="light" class="mb-3">
                                                            <div>
                                                                <b-row>
                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'Shared.Provider'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b v-if="s.therapistName">{{
                                                                            s.therapistName
                                                                        }}</b>
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nProvider'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.therapistName"
                                                                            >{{
                                                                                s.signedDate
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                s.signedDate ===
                                                                                    null &&
                                                                                    !s.isSigned
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplan.NoSigned'
                                                                                )
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'treatmentplanList.CoProvider'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b
                                                                            v-if="
                                                                                s.coTherapistName &&
                                                                                    s.coTherapistName.trim() !==
                                                                                        ''
                                                                            "
                                                                            >{{
                                                                                s.coTherapistName
                                                                            }}</b
                                                                        >
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nCoProSign'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.coTherapistName"
                                                                            >{{
                                                                                s.coSignedDate
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                s.coSignedDate ===
                                                                                    null &&
                                                                                    !s.isCosigned
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplan.NoSigned'
                                                                                )
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $tc('Shared.Patient')
                                                                        }}</small
                                                                        ><br />
                                                                        <b
                                                                            v-if="
                                                                                s.patientName !==
                                                                                    '' &&
                                                                                    s.refuseSigned ===
                                                                                        false
                                                                            "
                                                                            >{{ s.patientName }}</b
                                                                        >
                                                                        <b v-if="s.refuseSigned">{{
                                                                            $t(
                                                                                'modalAddSignature.pRefused'
                                                                            )
                                                                        }}</b>
                                                                        <b
                                                                            v-if="
                                                                                s.refuseSigned ===
                                                                                    false &&
                                                                                    s.patientName ===
                                                                                        ''
                                                                            "
                                                                            >{{
                                                                                $t(
                                                                                    'treatmentplanList.nPaSign'
                                                                                )
                                                                            }}</b
                                                                        >

                                                                        <br />
                                                                        <span
                                                                            v-if="
                                                                                s.patientSignedDate
                                                                            "
                                                                            >{{
                                                                                s.patientSignedDate
                                                                            }}</span
                                                                        >
                                                                    </div>

                                                                    <div
                                                                        class="float-left col-md-3 text-muted p-item"
                                                                    >
                                                                        <small>{{
                                                                            $t(
                                                                                'modalAddSignature.guardian'
                                                                            )
                                                                        }}</small
                                                                        ><br />
                                                                        <b v-if="s.guardianName">{{
                                                                            s.guardianName
                                                                        }}</b>
                                                                        <b v-else>{{
                                                                            $t(
                                                                                'treatmentplanList.nGaSign'
                                                                            )
                                                                        }}</b>
                                                                        <br />
                                                                        <span
                                                                            v-if="s.guardianName"
                                                                            >{{
                                                                                s.guardianSignedDate
                                                                            }}</span
                                                                        >
                                                                    </div>
                                                                </b-row>
                                                            </div>
                                                        </b-card>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <mdModalEditSignature
                    @ModalTreatmentPlanSignatureCANCEL="OnReturnSignatureCancelMedez($event)"
                    v-bind:UseInModal="true"
                    v-bind:NotesId="NotesId"
                    v-bind:Signatures="TreatmentPlan.signatures"
                    v-bind:PatientCode="this.PatientCode"
                    v-if="showModalSignatureMedez"
                    v-bind:ModalId="'modalIdEditSignature'"
                    v-bind:TitleWindow="$t('modalAddSignature.sign', { label: $t('Shared.Edit') })"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:SignatureEdit="SignatureEdit"
                />

                <mdModalEditTPProblem
                    @ModalTPEditProblemCANCEL="OnEditTPProblemCancelMedez($event)"
                    v-if="VisibleEditTPProblemMedez"
                    v-bind:ModalId="'modalIdEditTPProblem'"
                    v-bind:TitleWindow="$t('treatmentplanList.editP')"
                    v-bind:ProbDesc="ProbDesc"
                    v-bind:DiagDesc="DiagDesc"
                    v-bind:DiagCode="DiagCode"
                    v-bind:ProblemDateIdentified="ProblemDateIdentified"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <mdModalEditTPBehavioral
                    v-if="VisibleEditTPBehavioralMedez"
                    v-bind:ModalId="'modalIdEditBehaviral'"
                    v-bind:BehavioralsProp="BehavioralsModal"
                    v-bind:TitleWindow="$t('Shared.PsychosocialEnvironmental')"
                    v-bind:probCode="this.probCode"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:ProblemRecId="ProblemRecId"
                    @ModalTPEditBehavioralCANCEL="ModalTPEditBehavioralCANCELMedez"
                    v-bind:ItemSelected="ItemSelected"
                />

                <mdModalAddGoal
                    @ModalTPGoal="ModalTPGoalCANCELMedez"
                    v-if="VisibleAddGoalsMedez"
                    v-bind:ModalId="'modalIdAddGoals'"
                    v-bind:TitleWindow="$t('treatmentplanList.addG')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                />

                <mdModalAddObjective
                    @ModalTPObjective="ModalTPObjectiveCANCELMedez"
                    v-if="VisibleAddObjetiveMedez"
                    v-bind:ModalId="'modalIdAddObjective'"
                    v-bind:TitleWindow="$t('treatmentplanList.addObj')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    v-bind:GoalListObj="GoalListObj"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalRecId="GoalRecId"
                />

                <mdModalEditGoal
                    @ModalTPEditGoal="ModalTPEditGoalMedez"
                    v-if="VisibleEditGoalMedez"
                    v-bind:ModalId="'modalIdEditGoal'"
                    v-bind:TitleWindow="$t('treatmentplanList.editG')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalEdit="this.GoalEdit"
                />

                <mdModalAddIntervention
                    @ModalTPAddIntervention="ModalTPAddInterventionMedez"
                    v-if="VisibleAddInterventionMedez"
                    v-bind:ModalId="'modalIdAddIntervention'"
                    v-bind:TitleWindow="$t('treatmentplanList.addInt')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:GoalListObj="GoalListObj"
                    v-bind:ObjectiveListObj="ObjectiveListObj"
                    v-bind:GoalRecId="GoalRecId"
                    v-bind:ObjRecId="ObjRecId"
                />

                <mdModalEditObjective
                    @ModalTPEditObjective="ModalTPEditObjectiveMedez"
                    v-if="VisibleEditObjectiveMedez"
                    v-bind:ModalId="'modalIdEditObjective'"
                    v-bind:TitleWindow="$t('treatmentplanList.editObj')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:ObjectiveEdit="this.ObjectiveEdit"
                />

                <mdModalEditIntervention
                    @ModalTPEditIntervention="ModalTPEditInterventionMedez"
                    v-if="VisibleEditInterventionMedez"
                    v-bind:ModalId="'modalIdEditIntervention'"
                    v-bind:TitleWindow="$t('treatmentplanList.editInt')"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    @RefreshGetTP="RefreshGetTP"
                    v-bind:IntEditModal="this.InterventionEdit"
                />

                <mdModalAddSignature
                    @ModalTPAddSignature="ModalTPAddSignatureMedez"
                    v-if="VisibleAddSignatureMedez"
                    v-bind:NotesId="NotesId"
                    v-bind:PatientCode="this.PatientCode"
                    v-bind:ModalId="'modalIdAddSignature'"
                    v-bind:TitleWindow="$t('modalAddSignature.sign', { label: $t('Shared.Add') })"
                    v-bind:groupId="this.groupId"
                    v-bind:headerId="this.headerId"
                    v-bind:probCode="this.probCode"
                    v-bind:ProblemRecId="ProblemRecId"
                    v-bind:UseInModal="true"
                    @RefreshGetTP="RefreshGetTP"
                />

                <TreatmentPlanRep
                    v-if="isReportVisible"
                    :closeWindow="closeParamRepWindow"
                    :patientCode="parameter.AdmissionId"
                    :recNo="parameter.AdmissionId"
                    :notesId="NotesId"
                    :version="this.VersionModel.code"
                />
                <ObjectiveReviewRep
                    v-if="isObjectiveRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="this.RegistrationInfo.recordId"
                    :objRecId="ObjRecId"
                />
                <ProblemReviewRep
                    v-if="isProblemRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="this.RegistrationInfo.recordId"
                    :problemRecId="ProblemRecId"
                />
                <TreatmentPlanProblemRep
                    v-if="isTreatmentPlanProblemRepVisible"
                    :closeWindow="closeParamRepWindow"
                    :recNo="parameter.AdmissionId"
                    :notesId="NotesId"
                    :probRecId="ProblemRecId"
                    :version="this.VersionModel.code"
                />
                <!-- <div class="space-actions"></div>
    <div class="page-actions" v-if="VisibleSignature">
      <b-dropdown split  :text="$tc('Shared.ActionsTxt',2)" class="mx-2" variant="primary" v-if="VisibleSignature">
        <b-dropdown-item-button v-on:click="VoidClick" v-if="!isReadOnly && !ReadOnlyProp">
          {{ $t('Shared.Void') }}
        </b-dropdown-item-button>

        <b-dropdown-item-button v-on:click="showReport">
          {{ $t('Shared.Report') }}
        </b-dropdown-item-button>
      </b-dropdown>
    </div>-->
            </div>

            <div v-show="isAddwlTP" id="AddProblemsWlTreatmentPlan">
                <div class="row">
                    <div class="col-12">
                        <MdTitleRegInfo
                            v-bind:RegistrationInfo="RegistrationInfo"
                            v-bind:titlePrefix="$t('Shared.treatmentplan')"
                            v-bind:IsClinical="true"
                            v-bind:titleRef="'titleElementTreatmentplan'"
                            v-bind:patientCode="this.PatientCode"
                        >
                        </MdTitleRegInfo>
                    </div>
                </div>
                <MdWizard
                    ref="wizardWiley"
                    :steps="stepsWiley"
                    :finalStepLabel="$t('treatmentplan.finish')"
                    :nextStepLabel="$t('treatmentplan.Next')"
                    :previousStepLabel="$t('Shared.Back')"
                    :onNext="nextClickedTPWiley"
                    :onBack="backClicked"
                >
                    <div slot="Diagnoses">
                        <MdTitle
                            v-bind:Text="DiagnoseLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Diagnosis'"
                            class="subtitleWizard"
                        />
                        <b-row>
                            <div class="col-md-12">
                                <MdLookup
                                    v-bind:ModelCode="diagCode"
                                    v-bind:ModelDescription="diagDesc"
                                    v-bind:Label="$t('Shared.Diagnosis')"
                                    v-bind:RefCode="'Diagnosis'"
                                    v-bind:Fields="BaseFields"
                                    v-bind:Api="'WileyTxDiagnoses?DSM=5'"
                                    v-bind:FieldCode="'icd10code'"
                                    v-bind:FieldDescription="'description'"
                                    :GetValues="onCodeConditionOk"
                                    :SearchFieldCode="'icd10code'"
                                />
                            </div>
                            <div class="col-md-12 text-muted px-4 mt-3">
                                <p>{{ $t('treatmentplan.Text1') }}</p>
                                <p>{{ $t('treatmentplan.Text2') }}</p>
                                <p>{{ $t('treatmentplan.Text3') }}</p>
                                <hr class="mt-5" />
                                <p class="wiley fadeIn">
                                    {{ $t('treatmentplan.Text4')
                                    }}<a
                                        href="https://www.wiley.com/learn/practice_planners/index.html"
                                        target="_blank"
                                        ><img
                                            src="../../../../src/assets/images/wiley-practice_planners_logo.svg"
                                            alt="Wiley's PracticePlanners"
                                    /></a>
                                </p>
                            </div>
                        </b-row>
                    </div>
                    <div slot="Problems">
                        <MdTitle
                            v-bind:Text="ProblemLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Problem'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="ShowMessageIsEmptyProblems"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <b-row>
                            <b-col lg="6" md="6" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.pGroup')"
                                    v-bind:Options="ProblemGroupOptions"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'groupId'"
                                    v-bind:AllowEmpty="false"
                                    v-bind:Multiple="false"
                                    v-bind:Model="ProblemGroupModel"
                                    :Input="ChangeProblemGroup"
                                />
                            </b-col>
                            <div class="col-md-6 text-muted mt-3">
                                <p>{{ $t('treatmentplan.proGroupText') }}</p>
                            </div>
                        </b-row>
                        <b-row v-if="this.itemsProblems.length > 0">
                            <b-col md="12">
                                <RadioGroup
                                    v-model="Problem"
                                    v-bind:Options="itemsProblems"
                                    v-bind:LabelProp="$t('treatmentplan.Problems')"
                                    v-bind:OnChangeProp="OnChangeProblem"
                                    v-bind:columnCount="3"
                                    :textField="'description'"
                                    :valueField="'problemNumber'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Behavioral">
                        <MdTitle
                            v-bind:Text="BehavioralLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Behavioral'"
                            class="subtitleWizard"
                        />
                        <b-row>
                            <b-col lg="12" md="12" sm="12">
                                <MdCheckListBox2
                                    v-model="behavioralModel"
                                    v-bind:Options="BehavioralList"
                                    v-bind:OnChangeProp="OnChangeBehavioral"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'definitionNumber'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Goals">
                        <MdTitle
                            v-bind:Text="GoalLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Goal'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleGoals"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <b-row>
                            <b-col lg="12" md="12" sm="12">
                                <MdCheckListBox2
                                    v-model="GoalsModel"
                                    v-bind:Options="GoalsList"
                                    v-bind:OnChangeProp="OnChangeGoals"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'goalNumber'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Objectives">
                        <MdTitle
                            v-bind:Text="ObjectiveLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Objective'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleObjectives"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <div class="ObjWizardLegend">
                            <b-icon icon="exclamation-circle" style="color: #090;"></b-icon>
                            {{ $t('treatmentplan.Text5') }}
                        </div>

                        <b-row v-for="(item, index) in ObjectiveModel" :key="index">
                            <span class="InterventionByObjWizard"
                                >{{ $t('modalAddGoal.goals') }} {{ index + 1 }} -
                                {{ item.description }}</span
                            >
                            <b-col lg="12" md="12" sm="12" class="mb-3">
                                <MdCheckListBoxByCycle
                                    v-model="item.selectedCode"
                                    v-bind:Options="item.objectives"
                                    v-bind:OnChangeProp="OnChangeObjectives"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'objectiveNumber'"
                                />
                            </b-col>
                        </b-row>
                        <!-- <div v-if="this.HaveObjectiveEvidenceBased()" class="ObjWizardLegend" v-b-tooltip.hover title="Presented in green labels"><b-icon icon="circle-fill" font-scale=".8"></b-icon> evidence based treatment</div>-->
                    </div>
                    <div slot="Interventions">
                        <MdTitle
                            v-bind:Text="InterventionLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Intervention'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleIntervention"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <div class="ObjWizardLegend">
                            <b-icon icon="exclamation-circle" style="color: #090;"></b-icon>
                            {{ $t('treatmentplan.Text5') }}
                        </div>
                        <b-row v-for="(item, index) in InterventionsModel" :key="index">
                            <span
                                class="InterventionByObjWizard rounded"
                                v-if="item.objectives.length > 0"
                                >{{ $t('modalAddGoal.goals') }} {{ index + 1 }} -
                                {{ item.description }}</span
                            >
                            <div v-for="(obj, i) in item.objectives" :key="i" class="w-100">
                                <div class="ObjsWizard">
                                    {{ $t('modalEditObjective.Objective') }} {{ i + 1 }} -
                                    {{ obj.description }}
                                </div>
                                <MdCheckListBoxByCycle
                                    class="ml-3 mx-4"
                                    v-model="obj.interventionsSelected"
                                    v-bind:Options="obj.interventions"
                                    v-bind:OnChangeProp="OnChangeInterventions"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'interventionNumber'"
                                />
                            </div>
                        </b-row>
                    </div>
                    <div slot="Summary">
                        <MdTitle
                            v-bind:Text="$t('Shared.Summary')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Summary'"
                            class="subtitleWizard"
                        />

                        <div id="summaryDiagnose" class="wizardSummary">
                            <div class="wizardSumLabel">
                                <span class="wizardSumNum"><b-icon icon="check"></b-icon></span
                                >{{ $t('Shared.Diagnosis') }}
                            </div>
                            <div class="ml-3 mt-2">{{ this.diagDesc }} - {{ this.diagCode }}</div>
                        </div>
                        <br />
                        <div id="summaryProblem" class="wizardSummary">
                            <div class="wizardSumLabel">
                                <span class="wizardSumNum"><b-icon icon="check"></b-icon></span
                                >{{ $t('Shared.Problem') }}
                            </div>
                            <div class="ml-3 mt-2">{{ this.ProblemD }}</div>
                        </div>
                        <br />
                        <div id="summarybehavioral" class="wizardSummary">
                            <div class="wizardSumLabel">
                                <span class="wizardSumNum"><b-icon icon="check"></b-icon></span
                                >{{ $t('treatmentplan.Behavioral') }}
                            </div>
                            <div class="ml-3 mt-2">
                                <ul>
                                    <li
                                        v-for="(item, index) in this.SelectedBehavioral"
                                        :key="index"
                                    >
                                        {{ item }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <br />

                        <div id="summarygoals" class="wizardSummary">
                            <div v-for="(item, index) in this.InterventionsModel" :key="index">
                                <div class="wizardSumLabel">
                                    <span class="wizardSumNum">
                                        <b-icon icon="check"></b-icon> </span
                                    >{{ $t('modalEditGoal.goal') }} {{ index + 1 }}
                                </div>
                                <div class="wizardGoalsDesc">
                                    {{ item.description }}
                                </div>

                                <div class="ml-3 mt-2 mb-4">
                                    <div
                                        class="wizObjectives"
                                        v-for="(obj, indexobj) in item.objectives"
                                        :key="indexobj"
                                    >
                                        <b-icon icon="check" class="wizardCheckObj"></b-icon>
                                        <span
                                            >{{ $t('modalEditObjective.Objective') }}
                                            {{ indexobj + 1 }} - {{ obj.description }}</span
                                        >
                                        <div class="ml-3 mt-2">
                                            <ul>
                                                <li
                                                    v-for="(itv,
                                                    indexitv) in obj.itvDdescriptionSelected"
                                                    :key="indexitv"
                                                >
                                                    {{ $t('Intervention.interV') }}
                                                    {{ indexitv + 1 }} - {{ itv.description }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />

                        <MdTitle
                            v-bind:Text="$t('modalAddSignature.sign', { label: '' })"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Signature'"
                            class="subtitleWizard"
                        />
                        <div class="card bg-light">
                            <div class="card-body">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Provider')"
                                            v-bind:Options="ProviderList"
                                            v-bind:FieldDescription="'therapistName'"
                                            v-bind:FieldCode="'therapistCode'"
                                            v-bind:Model="ProviderModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownProvider"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'checkbox-Sign'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="SignProvider"
                                            v-on:change="onSignatureTPWiley"
                                            v-bind:Tag="'SignTreatmentPlanSignatureWiley'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('MdNote.Cosignedby')"
                                            v-bind:Options="CoProviderList"
                                            v-bind:FieldDescription="'coTherapistName'"
                                            v-bind:FieldCode="'coTherapistCode'"
                                            v-bind:Model="CoProviderModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownCoProvider"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'Co-checkbox-Sign'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="SignCoProvider"
                                            v-on:change="onCoSignatureTPWiley"
                                            v-bind:Tag="'CoSignTreatmentPlanSignatureWiley'"
                                        />
                                    </b-col>

                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$tc('Incident.IncPartClient')"
                                            v-bind:Options="ClientList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="ClientModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownClientWiley"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'checkbox-Client'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:isReadOnly="disabledCheckClient"
                                            v-model="ClientCheckModel"
                                            v-bind:UncheckedValue="false"
                                            v-on:change="onSignatureClientWiley($event)"
                                            v-bind:Tag="'TreatmentPlanSignatureClientWiley'"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                        </div>

                        <hr class="mt-3" />
                        <p class="wiley fadeIn">
                            {{ $t('treatmentplan.Text6') }}
                            <a
                                href="https://www.wiley.com/learn/practice_planners/index.html"
                                target="_blank"
                                ><img
                                    src="../../../../src/assets/images/wiley-practice_planners_logo.svg"
                                    alt="Wiley's PracticePlanners"
                            /></a>
                        </p>
                    </div>
                </MdWizard>

                <MdPasswordDlg
                    v-if="showSignPasswordWiley"
                    v-bind:Type="TypePassWord"
                    v-bind:EmployeeCode="EmployeeCodeSelected"
                    @getModalPassword="onModalPasswordResultWiley($event)"
                />
                <wyModalSignPatientGuardian
                    @ModalTPSignPatientGuardian="OnReturnSignWiley($event)"
                    @ModalTPSignPatientGuardianWizardOK="OnReturnOKWizard($event)"
                    v-if="showModalSignPatientGuardianWiley"
                    v-bind:Option="option"
                    v-bind:ModalId="'modalIdSignPatientGuardian'"
                    v-bind:ItemChecked="itemChecked"
                    v-bind:PatientCode="PatientCode"
                    v-bind:TitleWindow="labelSign"
                    v-bind:ShowGuardianDrop="ShowGuardianDrop"
                />
            </div>

            <div v-show="isAddMdTP" id="AddProblemsMdTreatmentPlan">
                <div class="row">
                    <div class="col-12">
                        <MdTitleRegInfo
                            v-bind:RegistrationInfo="RegistrationInfo"
                            v-bind:titlePrefix="$t('Shared.treatmentplan')"
                            v-bind:IsClinical="true"
                            v-bind:titleRef="'titleElementTreatmentplanMd'"
                            v-bind:patientCode="this.$route.params.id"
                        >
                        </MdTitleRegInfo>
                    </div>
                </div>
                <MdWizard
                    ref="wizardMedez"
                    :steps="stepsMedez"
                    :finalStepLabel="$t('treatmentplan.finish')"
                    :nextStepLabel="$t('treatmentplan.Next')"
                    :previousStepLabel="$t('Shared.Back')"
                    :onNext="nextClickedTPMedez"
                    :onBack="backClicked"
                >
                    <div slot="Problems">
                        <MdTitle
                            v-bind:Text="ProblemLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Problem'"
                            class="subtitleWizard"
                        />

                        <div
                            v-if="ShowMessageIsEmptyProblems"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>

                        <b-row v-if="this.itemsProblems.length > 0">
                            <b-col md="12">
                                <RadioGroup
                                    v-model="Problem"
                                    v-bind:Options="itemsProblems"
                                    v-bind:LabelProp="$t('treatmentplan.Problems')"
                                    v-bind:OnChangeProp="OnChangeProblemMedez"
                                    v-bind:columnCount="5"
                                    :textField="'name'"
                                    :valueField="'code'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Behavioral">
                        <MdTitle
                            v-bind:Text="BehavioralLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Behavioral'"
                            class="subtitleWizard"
                        />
                        <b-row v-for="(item, index) in this.problemAggregateList" :key="index">
                            <span class="InterventionByObjWizard">{{ item.name }}</span>
                            <b-col lg="12" md="12" sm="12" class="mb-3">
                                <MdCheckListBox2
                                    v-model="item.model"
                                    v-bind:Options="item.list"
                                    v-bind:OnChangeProp="OnChangeBehavioral"
                                    v-bind:columnCount="2"
                                    :textField="'name'"
                                    :valueField="'id'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Goals">
                        <MdTitle
                            v-bind:Text="GoalLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Goal'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleGoals"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <b-row>
                            <b-col lg="12" md="12" sm="12">
                                <MdCheckListBox2
                                    v-model="GoalsModel"
                                    v-bind:Options="GoalsList"
                                    v-bind:OnChangeProp="OnChangeGoals"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'code'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Objectives">
                        <MdTitle
                            v-bind:Text="ObjectiveLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Objective'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleObjectives"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <b-row v-for="(item, index) in ObjectiveModel" :key="index">
                            <span class="InterventionByObjWizard"
                                >{{ $t('modalAddGoal.goals') }} {{ index + 1 }} -
                                {{ item.goalDescription }}</span
                            >
                            <b-col lg="12" md="12" sm="12" class="mb-3">
                                <MdCheckListBoxByCycle
                                    v-model="item.selectedCode"
                                    v-bind:Options="item.objectives"
                                    v-bind:OnChangeProp="OnChangeObjectives"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'code'"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="Interventions">
                        <MdTitle
                            v-bind:Text="InterventionLabel"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Intervention'"
                            class="subtitleWizard"
                        />
                        <div
                            v-if="VisibleIntervention"
                            v-bind:style="emptyRecordsStyle"
                            role="alert"
                            aria-live="polite"
                        >
                            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                        </div>
                        <b-row v-for="(item, index) in InterventionsModel" :key="index">
                            <span
                                class="InterventionByObjWizard rounded"
                                v-if="item.objectives.length > 0"
                                >{{ $t('modalAddGoal.goals') }} {{ index + 1 }} -
                                {{ item.goalDescription }}</span
                            >
                            <div v-for="(obj, i) in item.objectives" :key="i" class="w-100">
                                <div class="ObjsWizard">
                                    {{ $t('modalEditObjective.Objective') }} {{ i + 1 }} -
                                    {{ obj.description }}
                                </div>
                                <MdCheckListBoxByCycle
                                    class="ml-3 mx-4"
                                    v-model="obj.interventionsSelected"
                                    v-bind:Options="obj.interventions"
                                    v-bind:OnChangeProp="OnChangeInterventionsMedez"
                                    v-bind:columnCount="1"
                                    :textField="'description'"
                                    :valueField="'code'"
                                />
                            </div>
                        </b-row>
                    </div>
                    <div slot="Summary">
                        <MdTitle
                            v-bind:Text="$t('Shared.Summary')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Summary'"
                            class="subtitleWizard"
                        />

                        <div id="summaryProblem" class="wizardSummary">
                            <div class="wizardSumLabel">
                                <span class="wizardSumNum"><b-icon icon="check"></b-icon></span
                                >{{ $t('Shared.Problem') }}
                            </div>
                            <div class="ml-3 mt-2">{{ this.ProblemD }}</div>
                        </div>
                        <br />

                        <div id="summarybehavioral" class="wizardSummary">
                            <div class="wizardSumLabel">
                                <span class="wizardSumNum"><b-icon icon="check"></b-icon></span
                                >{{ $t('Shared.PsychosocialEnvironmental') }}
                            </div>
                            <div class="ml-3 mt-2">
                                <div
                                    class="wizObjectives"
                                    v-for="(item, index) in this.problemAggregateList"
                                    :key="index"
                                >
                                    <b-icon icon="check" class="wizardCheckObj"></b-icon>
                                    <span> {{ item.name }} </span>
                                    <div class="ml-3 mt-2">
                                        <ul>
                                            <li
                                                v-for="(it, indexit) in limitSelectedAggregates(
                                                    item
                                                )"
                                                :key="indexit"
                                            >
                                                {{ it.name }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />

                        <div id="summarygoals" class="wizardSummary">
                            <div v-for="(item, index) in this.InterventionsModel" :key="index">
                                <div class="wizardSumLabel">
                                    <span class="wizardSumNum">
                                        <b-icon icon="check"></b-icon> </span
                                    >{{ $t('modalEditGoal.goal') }} {{ index + 1 }}
                                </div>
                                <div class="wizardGoalsDesc">
                                    {{ item.goalDescription }}
                                </div>

                                <div class="ml-3 mt-2 mb-4">
                                    <div
                                        class="wizObjectives"
                                        v-for="(obj, indexobj) in item.objectives"
                                        :key="indexobj"
                                    >
                                        <b-icon icon="check" class="wizardCheckObj"></b-icon>
                                        <span
                                            >{{ $t('modalEditObjective.Objective') }}
                                            {{ indexobj + 1 }} - {{ obj.description }}</span
                                        >
                                        <div class="ml-3 mt-2">
                                            <ul>
                                                <li
                                                    v-for="(itv,
                                                    indexitv) in obj.itvDdescriptionSelected"
                                                    :key="indexitv"
                                                >
                                                    {{ $t('Shared.Intervention') }}
                                                    {{ indexitv + 1 }} - {{ itv.description }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />

                        <MdTitle
                            v-bind:Text="$t('modalAddSignature.sign', { label: '' })"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'Signature'"
                            class="subtitleWizard"
                        />
                        <div class="card bg-light">
                            <div class="card-body">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Provider')"
                                            v-bind:Options="ProviderList"
                                            v-bind:FieldDescription="'therapistName'"
                                            v-bind:FieldCode="'therapistCode'"
                                            v-bind:Model="ProviderModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownProvider"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'checkbox-Sign'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="SignProvider"
                                            v-on:change="onSignatureTPMedez"
                                            v-bind:Tag="'SignTreatmentPlanSignature'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('MdNote.Cosignedby')"
                                            v-bind:Options="CoProviderList"
                                            v-bind:FieldDescription="'coTherapistName'"
                                            v-bind:FieldCode="'coTherapistCode'"
                                            v-bind:Model="CoProviderModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownCoProvider"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'Co-checkbox-Sign'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="SignCoProvider"
                                            v-on:change="onCoSignatureTPMedez"
                                            v-bind:Tag="'CoSignTreatmentPlanSignature'"
                                        />
                                    </b-col>

                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$tc('Incident.IncPartClient')"
                                            v-bind:Options="ClientList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="ClientModel"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownClientMedez"
                                        />
                                    </b-col>
                                    <b-col lg="1" sm="1" md="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('MdNote.Sign')"
                                            v-bind:Name="'checkbox-Client'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:isReadOnly="disabledCheckClient"
                                            v-model="ClientCheckModel"
                                            v-bind:UncheckedValue="false"
                                            v-on:change="onSignatureClientMedez($event)"
                                            v-bind:Tag="'TreatmentPlanSignatureClientMedez'"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                        </div>

                        <hr class="mt-3" />
                    </div>
                </MdWizard>

                <MdPasswordDlg
                    v-if="showSignPasswordMedez"
                    v-bind:Type="TypePassWord"
                    v-bind:EmployeeCode="EmployeeCodeSelected"
                    @getModalPassword="onModalPasswordResultMedez($event)"
                />

                <MdPasswordDlg
                    v-if="showSignPasswordSuperVisor"
                    v-bind:Type="'Sign'"
                    v-bind:VerificationType="'SupervisorPassword'"
                    @getModalPassword="onModalPasswordResultSuperVisor($event)"
                />

                <mdModalSignPatientGuardian
                    @ModalTPSignPatientGuardian="OnReturnSignMedez($event)"
                    @ModalTPSignPatientGuardianWizardOK="OnReturnOKWizard($event)"
                    v-if="showModalSignPatientGuardianMedez"
                    v-bind:Option="option"
                    v-bind:PatientCode="PatientCode"
                    v-bind:ModalId="'modalIdSignPatientGuardianMedez'"
                    v-bind:ItemChecked="itemChecked"
                    v-bind:TitleWindow="labelSign"
                    v-bind:ShowGuardianDrop="ShowGuardianDrop"
                />
            </div>

            <template #modal-footer="{ }">
                <b-row>
                    <b-col md="12">
                        <b-button class="secondary mx-2 btn-login pull-right" @click="emitEventOK">
                            {{ $t('Shared.Close') }}
                        </b-button>
                        <b-button
                            class="secondary mx-2 btn-login pull-right"
                            v-if="!isListing && items.length > 1"
                            @click="GotoTPOutComeList"
                        >
                            {{ $t('Shared.Back') }}
                        </b-button>
                        <div v-if="VisibleSignature && !isListing">
                            <b-dropdown
                                class="pull-right"
                                dropup
                                style="height:38px;"
                                split
                                :text="$tc('Shared.ActionsTxt', 2)"
                                variant="primary"
                                v-if="VisibleSignature"
                            >
                                <b-dropdown-item-button v-on:click="VoidClick" v-if="!isReadOnly">
                                    {{ $t('Shared.Void') }}
                                </b-dropdown-item-button>

                                <b-dropdown-item-button v-on:click="showReport">
                                    {{ $t('Shared.Report') }}
                                </b-dropdown-item-button>
                            </b-dropdown>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </b-modal>

        <Loading v-bind:IsLoading="this.Load" />
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import StorageService from '@/services/storage.service';
import Utils from '@/common/utils';
import TreatmentPlan from '@/services/treatmentplan.service';
import EmployeeService from '@/services/employee.service';
import LocalStorage from '@/services/storage.service';
import TreatmentPlanService from '@/services/treatmentplan.service';
import { EventBus } from '@/event-bus.js';
import Loading from '@/components/template/loading/Loading';
//import WlTreatmentPlan from '@/components/pages/wytreatmentplan/treatmentplan'

export default {
    name: 'TreatmentPlanOutCome',
    mixins: [ShowMessage, DBFunctions],
    components: { Loading },

    props: {
        ModalId: String,
        PatientCode: String,
        TitleWindow: String,
        ComponentKind: String,
        CustomFrame: String,
        isOpenInEmployeeInbox: Boolean,
        NotesIdByEmployeeInbox: String,
        AdmissionRecordId: String,
        HeaderObj: Object,
        VisibleBar: {
            default: true,
            type: Boolean
        },
        ReadOnlyProp: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            ItemSelected: [],
            GoalCodeList: [],
            ObjectiveCodeList: [],
            SignatureId: '',
            showSignPasswordSuperVisor: false,

            VisibleAddGoalsWiley: false,
            VisibleAddGoalsMedez: false,
            VisibleEditTPBehavioralWiley: false,
            VisibleEditTPBehavioralMedez: false,

            VisibleAddObjetiveMedez: false,
            VisibleEditGoalMedez: false,
            VisibleAddInterventionMedez: false,
            VisibleEditObjectiveMedez: false,
            VisibleEditInterventionMedez: false,
            VisibleAddSignatureMedez: false,
            VisibleEditTPProblemMedez: false,
            showModalSignatureMedez: false,

            showModalSignatureWiley: false,
            VisibleEditTPProblemWiley: false,
            VisibleBlankTPBehavioralWiley: false,
            VisibleAddObjetiveWiley: false,
            VisibleEditGoalWiley: false,
            VisibleAddInterventionWiley: false,
            VisibleEditObjectiveWiley: false,
            VisibleEditInterventionWiley: false,
            VisibleAddSignatureWiley: false,

            problemAggregateList: [],
            VisibleIntervention: false,
            VisibleObjectives: false,
            VisibleGoals: false,
            VisibleItemsProblems: false,
            Load: false,
            EmployeeCode: '',
            option: '',
            labelSign: '',
            DataModalGuardianSig: {},
            showSignPassword: false,
            showSignPasswordWiley: false,
            showSignPasswordMedez: false,
            EmployeeCodeSelected: '',
            ProviderList: [],
            itemChecked: {},
            CoProviderList: [],
            ContactList: [],
            ClientModel: { code: '', name: '' },
            ClientList: [
                { code: 'PatientSigned', name: this.$t('modalAddSignature.pSigned') },
                { code: 'PatientRefused', name: this.$t('modalAddSignature.pRefused') },
                { code: 'GuardianSigned', name: this.$t('modalAddSignature.gSigned') }
            ],
            ContactModel: '',
            CoProviderModel: { coTherapistCode: '', coTherapistName: '' },
            showModalSignPatientGuardian: false,
            showModalSignPatientGuardianMedez: false,
            showModalSignPatientGuardianWiley: false,
            ProviderModel: { therapistCode: '', therapistName: '' },
            SignProvider: false,
            SignCoProvider: false,
            ClientCheckModel: false,
            disabledCheckClient: false,
            SignPatient: false,
            SignRefused: false,
            SignContact: false,
            BaseFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'icd10code', sortable: true, label: this.$t('Shared.Code') }
            ],
            ObjData: {
                admissionId: this.AdmissionRecordId,
                patientCode: this.PatientCode,
                problem: {
                    probCode: '',
                    probDesc: '',
                    dsm5: '',
                    dsm5description: '',
                    problemGroup: '',
                    groupId: 0
                },

                problemDefinitions: [],
                goals: []
            },

            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },

            RegistrationInfo: {},
            diagCode: '',
            diagDesc: '',
            DiagnoseIndexSelected: 0,
            ProblemIndexSelected: 0,
            ProblemD: '',
            ProblemGroupModel: { description: '', groupId: 0 },
            behavioralModel: [],
            BehavioralList: [],
            ObjectiveList: [],
            ObjectiveModel: [],
            GoalNumberList: [],
            ObjectiveNumberList: [],
            GoalsList: [],
            Problem: -1,
            GoalsModel: [],
            SelectedDiagnosis: { description: '', icd10code: '' },
            SelectedProblem: { description: '', problemNumber: '', groupId: 0, customProblem: '' },
            SelectedBehavioral: [],
            SelectedGoals: [],
            SelectedIntervention: [],
            ProblemGroupOptions: [],
            InterventionsList: [],
            InterventionsModel: [],
            InterventionsModelCopy: [],
            HeaderDiag: {},
            HeaderProb: {},
            pageOptionsDiagnoses: [5, 10, 15],
            totalRowsDiagnoses: 1,
            currentPageDiagnoses: 1,
            perPageDiagnoses: 5,
            ShowMessageIsEmptyDiagnoses: false,
            refTableDiagnoses: 'RefTableTreatmentDiagnoses',
            pageOptionsProblems: [5, 10, 15, 20, 25, 30],
            totalRowsProblems: 1,
            currentPageProblems: 1,
            perPageProblems: 5,
            ShowMessageIsEmptyProblems: false,
            refTableProblems: 'RefTableTreatmentProblems',
            parameterDiag: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0
            },
            parameterProb: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                GroupId: 0
            },
            DiagnoseLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Diagnosis')
            }),
            ProblemLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Problem')
            }),
            BehavioralLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('treatmentplan.Behavioral')
            }),
            ObjectiveLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('modalAddObjective.objectives')
            }),
            InterventionLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Intervention')
            }),
            GoalLabel: this.$t('treatmentplan.labelSelect', {
                label: this.$t('modalAddGoal.goals')
            }),
            itemsDiagnoses: [],
            itemsProblems: [],
            ShowGuardianDrop: false,
            stepsMedez: [
                {
                    label: this.$t('Shared.Problem'),
                    slot: 'Problems'
                },
                {
                    label: this.$t('treatmentplan.Subproblem'),
                    slot: 'Behavioral'
                },
                {
                    label: this.$t('modalAddGoal.goals'),
                    slot: 'Goals'
                },
                {
                    label: this.$t('modalAddObjective.objectives'),
                    slot: 'Objectives'
                },
                {
                    label: this.$t('Shared.Intervention'),
                    slot: 'Interventions'
                },
                {
                    label: this.$t('Shared.Summary'),
                    slot: 'Summary'
                }
            ],

            stepsWiley: [
                {
                    label: this.$t('Shared.Diagnosis'),
                    slot: 'Diagnoses'
                },
                {
                    label: this.$t('Shared.Problem'),
                    slot: 'Problems'
                },
                {
                    label: this.$t('treatmentplan.Behavioral'),
                    slot: 'Behavioral'
                },
                {
                    label: this.$t('modalAddGoal.goals'),
                    slot: 'Goals'
                },
                {
                    label: this.$t('modalAddObjective.objectives'),
                    slot: 'Objectives'
                },
                {
                    label: this.$t('Shared.Intervention'),
                    slot: 'Interventions'
                },
                {
                    label: this.$t('Shared.Summary'),
                    slot: 'Summary'
                }
            ],

            isReportVisible: false,
            isObjectiveRepVisible: false,
            isProblemRepVisible: false,
            isTreatmentPlanProblemRepVisible: false,
            NoteOptions: {},
            VersionList: [],
            isAddwlTP: false,
            isAddMdTP: false,
            TreatmentPlanType: '',
            TreatmentPlanTypeCopy: '',
            isSupervisor: StorageService.IsSupervisor(),
            VersionModel: { code: '0', description: this.$t('MdNote.Current') },
            VisibleVersion: false,
            ProbDesc: '',
            DiagDesc: '',
            DiagCode: '',
            HeaderId: '',
            ProblemDateIdentified: '',
            ProblemRecId: '',
            groupId: 0,
            headerId: '',
            probCode: '',
            VisibleAddSignature: false,
            BehavioralsModal: [],
            GoalListObj: [],
            GoalRecId: '',
            ObjRecId: '',
            ObjectiveListObj: [],
            SignatureEdit: {},
            GoalEdit: {
                goalCode: '',
                goalRecId: '',
                dateIdentified: null,
                dateExpected: null,
                dateAchieve: null,
                status: {
                    code: '',
                    description: ''
                },
                description: ''
            },
            ObjectiveEdit: {
                objCode: '',
                objRecId: '',
                dateIdentified: null,
                dateExpected: null,
                dateAchieve: null,
                status: {
                    code: '',
                    description: ''
                },
                description: ''
            },

            InterventionEdit: {
                startDate: null,
                intCode: '',
                intDesc: '',
                therapistCode: '',
                intRecId: '',
                therapyCode: '',
                noAmt: null,
                amount: null,
                amountObj: { code: '', description: '' },
                frequency: null,
                frequencyObj: { code: '', description: '' },
                noDuration: null,
                duration: null,
                durationObj: { code: '', description: '' },
                noFrequency: null,
                coTherapistCode: null,
                isEvidenceBased: false,
                therapistName: '',
                coTherapistName: '',
                therapyCodes: [],
                therapyNames: []
            },

            visibleEditProblem: false,
            VisibleAddObjetive: false,
            VisibleEditGoal: false,
            VisibleEditIntervention: false,
            VisibleAddIntervention: false,
            VisibleEditObjective: false,
            VisibleAddGoals: false,
            VisibleBlankTPBehavioral: false,
            ModalIdEditProblemTP: 'ModalIdEditProblemTP',
            ModalIdEditBehavioralTP: 'ModalIdEditBehavioralTP',
            VisibleEditTPProblem: false,
            VisibleEditTPBehavioral: false,
            VisibleNoRecords: false,
            VisibleNoRecordsWithFilter: false,
            VisibleSignature: false,
            TreatmentPlan: {},
            showModalSignature: false,
            SelectedEdit: {},
            isReadOnly: false,
            ShowMessageIsEmpty: false,
            NotesId: '',
            FieldsDateArr: ['probDate', 'dateTimeCreate'],
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false
            },
            Header: {},
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                Code: '',
                AdmissionId: this.AdmissionRecordId,
                NotesId: this.NotesId,
                HeaderId: ''
            },
            items: [],

            Loading: true,
            isListing: true,
            isEditMode: false,
            pendingChanges: false,
            clickOK: false,
            patient: {},
            IsClinical: false,
            visibleTable: true,
            AppoitmentList: [],
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },

            fields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-rigth'
                },
                {
                    key: 'customFrameFriendly',
                    sortable: true,
                    label: this.$t('Shared.Type'),
                    class: 'text-rigth'
                }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            selected: [],
            currentAppointmentDB: {
                guid: '',
                activitytypecode: '',
                employee: {
                    firstname: '',
                    lastname: ''
                }
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    computed: {
        sortOptions() {
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        }
    },

    methods: {
        limitSelectedAggregates(item) {
            if (item && item.list && item.list.length) {
                return item.list.filter(v => item.model.some(m => m == v.id));
            }

            return null;
        },

        ChangeDropDownClient(value) {
            this.ClientModel = value ? value : { code: '', name: '' };
            this.showModalSignPatientGuardian = false;
            if (value) {
                if (value.code === 'PatientRefused') {
                    this.disabledCheckClient = true;
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ClientCheckModel = false;
                } else {
                    this.disabledCheckClient = false;
                }

                if (value.code === 'GuardianSigned') {
                    this.option = this.$t('modalAddSignature.guardian');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$t('modalAddSignature.guardian')
                    });
                    this.ShowGuardianDrop = true;
                }

                if (value.code === 'PatientSigned') {
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ShowGuardianDrop = false;
                }

                if (value.code === 'GuardianSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardian = true;
                } else if (value.code === 'PatientSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardian = true;
                } else {
                    this.showModalSignPatientGuardian = false;
                }
            }
        },

        ChangeDropDownClientWiley(value) {
            this.ClientModel = value ? value : { code: '', name: '' };
            this.showModalSignPatientGuardianWiley = false;
            this.ClientCheckModel = false;
            if (value) {
                if (value.code === 'PatientRefused') {
                    this.disabledCheckClient = true;
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ClientCheckModel = false;
                } else {
                    this.disabledCheckClient = false;
                }

                if (value.code === 'GuardianSigned') {
                    this.option = this.$t('modalAddSignature.guardian');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$t('modalAddSignature.guardian')
                    });
                    this.ShowGuardianDrop = true;
                }

                if (value.code === 'PatientSigned') {
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ShowGuardianDrop = false;
                }

                if (value.code === 'GuardianSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardianWiley = true;
                } else if (value.code === 'PatientSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardianWiley = true;
                } else {
                    this.showModalSignPatientGuardianWiley = false;
                }
            }
        },

        ChangeDropDownClientMedez(value) {
            this.ClientModel = value ? value : { code: '', name: '' };
            this.showModalSignPatientGuardianMedez = false;
            this.ClientCheckModel = false;
            if (value) {
                if (value.code === 'PatientRefused') {
                    this.disabledCheckClient = true;
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ClientCheckModel = false;
                } else {
                    this.disabledCheckClient = false;
                }

                if (value.code === 'GuardianSigned') {
                    this.option = this.$t('modalAddSignature.guardian');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$t('modalAddSignature.guardian')
                    });
                    this.ShowGuardianDrop = true;
                }

                if (value.code === 'PatientSigned') {
                    this.option = this.$tc('Shared.Patient');
                    this.labelSign = this.$t('modalAddSignature.sign', {
                        label: this.$tc('Shared.Patient')
                    });
                    this.ShowGuardianDrop = false;
                }

                if (value.code === 'GuardianSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardianMedez = true;
                } else if (value.code === 'PatientSigned' && this.ClientCheckModel) {
                    this.showModalSignPatientGuardianMedez = true;
                } else {
                    this.showModalSignPatientGuardianMedez = false;
                }
            }
        },

        onModalPasswordResult(result) {
            if (result.type === 'Sign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignProvider = false;
                    }
                } else {
                    this.SignProvider = false;
                }
            }
            if (result.type === 'Cosign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignCoProvider = false;
                    }
                } else {
                    this.SignCoProvider = false;
                }
            }

            this.showSignPassword = false;
        },

        onModalPasswordResultWiley(result) {
            if (result.type === 'Sign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignProvider = false;
                    }
                } else {
                    this.SignProvider = false;
                }
            }
            if (result.type === 'Cosign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignCoProvider = false;
                    }
                } else {
                    this.SignCoProvider = false;
                }
            }

            this.showSignPasswordWiley = false;
        },

        onModalPasswordResultMedez(result) {
            if (result.type === 'Sign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignProvider = false;
                    }
                } else {
                    this.SignProvider = false;
                }
            }
            if (result.type === 'Cosign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.SignCoProvider = false;
                    }
                } else {
                    this.SignCoProvider = false;
                }
            }

            this.showSignPasswordMedez = false;
        },

        OnReturnOKWizard(data) {
            this.DataModalGuardianSig = data;
        },

        OnReturnSign(data) {
            if (data.option === this.$tc('Shared.Patient')) {
                data.item.isPatientSigned = false;
                data.item.CheckGuardianReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }
            if (data.option === this.$t('modalAddSignature.guardian')) {
                data.item.guardianSigned = false;
                data.item.CheckPatientReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }

            this.showModalSignPatientGuardian = false;
        },

        OnReturnSignWiley(data) {
            if (data.option === this.$tc('Shared.Patient')) {
                data.item.isPatientSigned = false;
                data.item.CheckGuardianReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }
            if (data.option === this.$t('modalAddSignature.guardian')) {
                data.item.guardianSigned = false;
                data.item.CheckPatientReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }

            this.showModalSignPatientGuardianWiley = false;
        },

        OnReturnSignMedez(data) {
            if (data.option === this.$tc('Shared.Patient')) {
                data.item.isPatientSigned = false;
                data.item.CheckGuardianReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }
            if (data.option === this.$t('modalAddSignature.guardian')) {
                data.item.guardianSigned = false;
                data.item.CheckPatientReadOnly = false;
                data.item.CheckRefuseReadOnly = false;
                data.item.SelectGuardianReadOnly = false;
            }

            this.showModalSignPatientGuardianMedez = false;
        },

        onCoSignatureTP(value) {
            this.TypePassWord = 'Cosign';
            this.EmployeeCodeSelected = this.CoProviderModel.coTherapistCode;
            this.showSignPassword = value;
        },

        onSignatureTP(value) {
            this.TypePassWord = 'Sign';
            this.EmployeeCodeSelected = this.ProviderModel.therapistCode;
            this.showSignPassword = value;
        },

        onSignatureTPMedez(value) {
            this.TypePassWord = 'Sign';
            this.EmployeeCodeSelected = this.ProviderModel.therapistCode;
            this.showSignPasswordMedez = value;
        },

        onCoSignatureTPMedez(value) {
            this.TypePassWord = 'Cosign';
            this.EmployeeCodeSelected = this.CoProviderModel.coTherapistCode;
            this.showSignPasswordMedez = value;
        },

        onSignatureTPWiley(value) {
            this.TypePassWord = 'Sign';
            this.EmployeeCodeSelected = this.ProviderModel.therapistCode;
            this.showSignPasswordWiley = value;
        },
        onCoSignatureTPWiley(value) {
            this.TypePassWord = 'Sign';
            this.EmployeeCodeSelected = this.ProviderModel.therapistCode;
            this.showSignPasswordWiley = value;
        },

        onSignatureClient(value) {
            this.showModalSignPatientGuardian =
                value &&
                (this.ClientModel.code === 'GuardianSigned' ||
                    this.ClientModel.code === 'PatientSigned')
                    ? true
                    : false;
        },

        onSignatureClientMedez(value) {
            this.showModalSignPatientGuardianMedez =
                value &&
                (this.ClientModel.code === 'GuardianSigned' ||
                    this.ClientModel.code === 'PatientSigned')
                    ? true
                    : false;
        },

        onSignatureClientWiley(value) {
            this.showModalSignPatientGuardianWiley =
                value &&
                (this.ClientModel.code === 'GuardianSigned' ||
                    this.ClientModel.code === 'PatientSigned')
                    ? true
                    : false;
        },

        ChangeDropDownProvider(value) {
            this.ProviderModel = value ? value : { therapistCode: '', therapistName: '' };
        },

        onSignatureGuardian() {},

        ChangeDropDownGuardian() {},

        onSignatureRefused() {},

        onSignaturePatient() {},

        ChangeDropDownCoProvider(value) {
            this.CoProviderModel = value ? value : { coTherapistCode: '', coTherapistName: '' };
        },

        async AddTX() {
            this.PrepareData();
            this.Load = true;
            if (
                this.ObjData.signature.therapistCode !== '' &&
                this.ObjData.signature.therapistCode !== null
            ) {
                if (this.ObjData.signature.isSigned) {
                    await TreatmentPlanService.Add(this.ObjData)
                        .then(response => {
                            if (response.status == '200') {
                                this.pendingChanges = false;

                                this.isAddwlTP = false;
                                this.TreatmentPlanType = this.TreatmentPlanTypeCopy;
                                this.SearchProblems();

                                setTimeout(
                                    () =>
                                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: 'success'
                                        }),
                                    50
                                );
                            }

                            this.Load = false;
                        })
                        .catch(error => {
                            this.Load = false;
                            if (!error.response) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.retrieveInfo'),
                                    'error'
                                );
                            } else if (error.response.status === 400) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            } else if (error.response.status === 500) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.ThereWereSomeError'),
                                    'error'
                                );
                            } else {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            }
                        });
                } else {
                    this.Load = false;
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('treatmentplan.pSignMsg'),
                        'error'
                    );
                    return;
                }
            } else {
                this.Load = false;
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('treatmentplan.pSelectMsg'),
                    'error'
                );
                return;
            }
        },

        PrepareData() {
            this.ObjData.problem.probCode = this.Problem.toString();
            this.ObjData.problem.dsm5 = this.diagCode;
            this.ObjData.problem.probDesc = this.ProblemD;
            this.ObjData.problem.dsm5description = this.diagDesc;
            this.ObjData.problem.problemGroup = this.ProblemGroupModel.description;
            this.ObjData.problem.groupId = this.ProblemGroupModel.groupId;
            this.ObjData.NotesId = this.NotesId;

            this.ObjData.problemDefinitions = [];

            this.ObjData.signature = {
                therapistCode: this.ProviderModel.therapistCode,
                coTherapistCode: this.CoProviderModel.coTherapistCode,
                patientCode: this.PatientCode,
                isSigned: this.SignProvider,
                isCosigned: this.SignCoProvider,
                isPatientSigned:
                    this.ClientCheckModel === true && this.ClientModel.code === 'PatientSigned'
                        ? true
                        : false,
                guardianSigned:
                    this.ClientCheckModel === true && this.ClientModel.code === 'GuardianSigned'
                        ? true
                        : false,
                refuseSigned: this.ClientModel.code === 'PatientRefused' ? true : false,
                image: this.DataModalGuardianSig.base64,
                contactRecNo:
                    this.DataModalGuardianSig.guardianCode !== '' &&
                    this.DataModalGuardianSig.guardianCode !== null
                        ? parseInt(this.DataModalGuardianSig.guardianCode)
                        : null
            };

            for (var i = 0; i < this.behavioralModel.length; i++) {
                this.ObjData.problemDefinitions.push({
                    definitionNumber: this.behavioralModel[i].toString(),
                    definitionDescription: this.SelectedBehavioral[i]
                });
            }

            this.ObjData.goals = [];
            let Dataobjectives = [];
            let Datainterventions = [];

            for (var j = 0; j < this.InterventionsModel.length; j++) {
                let goalCode = this.InterventionsModel[j].goalNumber.toString();
                let goalDesc = this.InterventionsModel[j].description;
                for (var k = 0; k < this.InterventionsModel[j].objectives.length; k++) {
                    let objCode = this.InterventionsModel[j].objectives[
                        k
                    ].objectiveNumber.toString();
                    let objDesc = this.InterventionsModel[j].objectives[k].description;
                    let isEvidenceBasedObj = this.InterventionsModel[j].objectives[k]
                        .isEvidenceBased;

                    for (
                        var l = 0;
                        l < this.InterventionsModel[j].objectives[k].interventionsSelected.length;
                        l++
                    ) {
                        let intCode = this.InterventionsModel[j].objectives[
                            k
                        ].interventionsSelected[l].toString();
                        let intDesc = this.InterventionsModel[j].objectives[k]
                            .itvDdescriptionSelected[l].description;
                        let isEvidenceBasedInt = this.InterventionsModel[j].objectives[k]
                            .itvDdescriptionSelected[l].isEvidenceBased;

                        Datainterventions.push({
                            intCode: intCode,
                            intDesc: intDesc,
                            isEvidenceBased: isEvidenceBasedInt
                        });
                    }
                    Dataobjectives.push({
                        objCode: objCode,
                        objDesc: objDesc,
                        isEvidenceBased: isEvidenceBasedObj,
                        interventions: Datainterventions
                    });
                    Datainterventions = [];
                }
                this.ObjData.goals.push({
                    goalCode: goalCode,
                    goalDesc: goalDesc,
                    objectives: Dataobjectives
                });
                Dataobjectives = [];
            }
        },
        nextClickedTPMedez(currentPage) {
            if (currentPage === 0) {
                if (this.Problem !== -1) {
                    this.getMedTxProblemAggregates();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.proSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 1) {
                if (
                    this.problemAggregateList.length == 0 ||
                    this.problemAggregateList.every(item => item.model.length > 0)
                ) {
                    this.getMedTxGoals();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.bSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 2) {
                if (this.GoalsModel.length > 0) {
                    this.getMedTxObjectives();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.gSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 3) {
                if (this.IsSelectedObjectives()) {
                    this.getMedTxInterventions();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.oSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 4) {
                if (this.IsSelectedInterventions()) {
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.iSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 5) {
                this.SaveProblemMedez();
                return true;
            }
        },

        async SaveProblemMedez() {
            await this.AddTXMedez();
        },

        PrepareDataMedez() {
            this.ObjData.problem.probCode = this.Problem.toString();
            this.ObjData.problem.dsm5 = this.diagCode;
            this.ObjData.problem.probDesc = this.ProblemD;
            this.ObjData.problem.dsm5description = this.diagDesc;
            this.ObjData.problem.problemGroup = this.ProblemGroupModel.description;
            this.ObjData.problem.groupId = this.ProblemGroupModel.groupId;
            this.ObjData.NotesId = this.NotesId;

            this.ObjData.signature = {
                therapistCode: this.ProviderModel.therapistCode,
                coTherapistCode: this.CoProviderModel.coTherapistCode,
                patientCode: this.PatientCode,
                isSigned: this.SignProvider,
                isCosigned: this.SignCoProvider,
                isPatientSigned:
                    this.ClientCheckModel === true && this.ClientModel.code === 'PatientSigned'
                        ? true
                        : false,
                guardianSigned:
                    this.ClientCheckModel === true && this.ClientModel.code === 'GuardianSigned'
                        ? true
                        : false,
                refuseSigned: this.ClientModel.code === 'PatientRefused' ? true : false,
                image: this.DataModalGuardianSig.base64,
                contactRecNo:
                    this.DataModalGuardianSig.guardianCode !== '' &&
                    this.DataModalGuardianSig.guardianCode !== null
                        ? parseInt(this.DataModalGuardianSig.guardianCode)
                        : null
            };

            this.ObjData.problemAggregates = [];

            for (let i = 0; i < this.problemAggregateList.length; i++) {
                let agg = this.problemAggregateList[i];
                let selected = [];
                for (let j = 0; j < agg.model.length; j++) {
                    let selIndex = agg.model[j];
                    if (selIndex >= 0 && selIndex < agg.list.length) {
                        selected.push(agg.list[selIndex].name);
                    }
                }
                this.ObjData.problemAggregates.push({
                    aggName: agg.name,
                    selectionValues: selected
                });
            }

            this.ObjData.problemDefinitions = [];
            this.ObjData.goals = [];
            let Dataobjectives = [];
            let Datainterventions = [];

            for (var j = 0; j < this.InterventionsModel.length; j++) {
                let goalCode = this.InterventionsModel[j].goalCode;
                let goalDesc = this.InterventionsModel[j].goalDescription;
                for (var k = 0; k < this.InterventionsModel[j].objectives.length; k++) {
                    let objCode = this.InterventionsModel[j].objectives[k].code;
                    let objDesc = this.InterventionsModel[j].objectives[k].description;

                    for (
                        var l = 0;
                        l < this.InterventionsModel[j].objectives[k].interventionsSelected.length;
                        l++
                    ) {
                        let intCode = this.InterventionsModel[j].objectives[
                            k
                        ].interventionsSelected[l].toString();
                        let intDesc = this.InterventionsModel[j].objectives[k]
                            .itvDdescriptionSelected[l].description;

                        Datainterventions.push({ intCode: intCode, intDesc: intDesc });
                    }
                    Dataobjectives.push({
                        objCode: objCode,
                        objDesc: objDesc,
                        interventions: Datainterventions
                    });
                    Datainterventions = [];
                }
                this.ObjData.goals.push({
                    goalCode: goalCode,
                    goalDesc: goalDesc,
                    objectives: Dataobjectives
                });
                Dataobjectives = [];
            }
        },

        async AddTXMedez() {
            this.PrepareDataMedez();
            this.Load = true;
            if (
                this.ObjData.signature.therapistCode !== '' &&
                this.ObjData.signature.therapistCode !== null
            ) {
                if (this.ObjData.signature.isSigned) {
                    await TreatmentPlanService.Add(this.ObjData)
                        .then(response => {
                            if (response.status == '200') {
                                this.pendingChanges = false;

                                this.isAddMdTP = false;
                                this.TreatmentPlanType = this.TreatmentPlanTypeCopy;
                                this.SearchProblems();

                                setTimeout(
                                    () =>
                                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: 'success'
                                        }),
                                    50
                                );
                                /* this.pendingChanges = false;
                                setTimeout(() => 
                                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: "success"
                                })
                                , 50);*/
                            }

                            this.Load = false;
                        })
                        .catch(error => {
                            this.Load = false;
                            if (!error.response) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.retrieveInfo'),
                                    'error'
                                );
                            } else if (error.response.status === 400) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            } else if (error.response.status === 500) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.ThereWereSomeError'),
                                    'error'
                                );
                            } else {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            }
                        });
                } else {
                    this.Load = false;
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('treatmentplan.pSignMsg'),
                        'error'
                    );
                    return;
                }
            } else {
                this.Load = false;
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('treatmentplan.pSelectMsg'),
                    'error'
                );
                return;
            }
        },

        getMedTxGoals() {
            this.Load = true;
            var parameter = {
                ProblemNumber: this.Problem
            };
            TreatmentPlanService.getMedTxGoals(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.GoalsList = response.data;
                        this.VisibleGoals = this.GoalsList.length === 0 ? true : false;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        IsIntInObjectivesMedez(goalCode, objectiveCode) {
            var objectives = this.ObjectiveModel.filter(item => item.goalCode === goalCode);
            if (objectives.length > 0) {
                var codes = objectives[0].selectedCode;
                for (var i = 0; i < codes.length; i++) {
                    if (codes[i] === objectiveCode) return true;
                }
            }
            return false;
        },

        RemoveObjectiveNotCheckedMedez() {
            let arrtemp = [];
            let arrposdelete = [];
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                for (var j = 0; j < this.InterventionsModel[i].objectives.length; j++) {
                    if (
                        this.IsIntInObjectivesMedez(
                            this.InterventionsModel[i].goalCode,
                            this.InterventionsModel[i].objectives[j].code
                        )
                    ) {
                        arrtemp.push(this.InterventionsModel[i].objectives[j]);
                    } else {
                        arrposdelete.push({ goalpos: i, objectivepos: j });
                    }
                }
                this.InterventionsModel[i].objectives =
                    arrtemp.length > 0 ? arrtemp : this.InterventionsModel[i].objectives;
                arrposdelete.reverse();
                for (var k = 0; k < arrposdelete.length; k++) {
                    this.InterventionsModel[arrposdelete[k].goalpos].objectives.splice(
                        arrposdelete[k].objectivepos,
                        1
                    );
                }
                arrtemp = [];
                arrposdelete = [];
            }
        },

        ObjectiveIsInIntervMedez(goalCode, objCode) {
            var objectives = this.InterventionsModel.filter(item => item.goalCode === goalCode);
            if (objectives.length > 0) {
                var objs = objectives[0].objectives;
                for (var i = 0; i < objs.length; i++) {
                    if (objs[i].code === objCode) return true;
                }
            }
            return false;
        },

        FindObjectiveInintevListMedez(goalCode, objCode) {
            var itv = this.InterventionsList.filter(item => item.goalCode === goalCode);
            var objtemp = {};
            if (itv.length > 0) {
                let itvtmp = itv[0];
                for (var i = 0; i < itvtmp.objectives.length; i++) {
                    if (itvtmp.objectives[i].code === objCode) {
                        objtemp = itvtmp.objectives[i];
                    }
                }
            }

            return objtemp;
        },

        AddObjMedez(goalCode, obj) {
            if (obj !== null) {
                for (var i = 0; i < this.InterventionsModel.length; i++) {
                    if (this.InterventionsModel[i].goalCode === goalCode) {
                        this.InterventionsModel[i].objectives.push(obj);
                    }
                }
            }
        },

        AddNewObjectivesMedez() {
            for (var i = 0; i < this.ObjectiveModel.length; i++) {
                for (var j = 0; j < this.ObjectiveModel[i].selectedCode.length; j++) {
                    if (
                        !this.ObjectiveIsInIntervMedez(
                            this.ObjectiveModel[i].goalCode,
                            this.ObjectiveModel[i].selectedCode[j]
                        )
                    ) {
                        var obj = this.FindObjectiveInintevListMedez(
                            this.ObjectiveModel[i].goalCode,
                            this.ObjectiveModel[i].selectedCode[j]
                        );
                        if (obj !== null) {
                            this.AddObjMedez(this.ObjectiveModel[i].goalCode, obj);
                        }
                    }
                }
            }
        },

        getMedTxInterventions() {
            this.PopulateListRequestInterventionMedez();
            this.Load = true;
            var parameter = {
                ProblemCode: this.Problem,
                GoalCodeList: this.GoalCodeList,
                ObjectiveCodeList: this.ObjectiveCodeList,
                IsWizard: true
            };
            TreatmentPlanService.getMedTxInterventions(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.InterventionsList = response.data;

                        this.InterventionsList.forEach(element => {
                            for (var i = 0; i < element.objectives.length; i++) {
                                element.objectives[i].class = 'InterventionByObjWizard';
                                element.objectives[i].classSummary = '';
                                element.objectives[i].interventionsSelected = element.objectives[
                                    i
                                ].interventionsSelected = [];
                                element.objectives[i].itvDdescriptionSelected = element.objectives[
                                    i
                                ].itvDdescriptionSelected = [];

                                for (
                                    var j = 0;
                                    j < element.objectives[i].interventions.length;
                                    j++
                                ) {
                                    element.objectives[i].interventions[j].class = '';
                                }
                            }

                            if (!this.ExistGoal(element.goalCode)) {
                                this.InterventionsModel.push({
                                    goalCode: element.goalCode,
                                    goalDescription: element.goalDescription,
                                    objectives: element.objectives
                                });
                            }
                            this.VisibleIntervention =
                                this.InterventionsModel.length === 0 ? true : false;
                        });

                        this.RemoveGoalNotCheckedMedez();
                        this.RemoveObjectiveNotCheckedMedez();
                        this.AddNewObjectivesMedez();
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        getMedTxObjectives() {
            this.Load = true;
            var parameter = {
                IsWizard: true,
                ProblemCode: this.Problem,
                GoalCodeList: this.GoalsModel
            };
            TreatmentPlanService.getMedTxObjectives(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.ObjectiveList = response.data;

                        let arrpos = [];
                        for (var i = 0; i < this.ObjectiveModel.length; i++) {
                            if (!this.ExistObjetiveinGoalsList(this.ObjectiveModel[i].goalCode)) {
                                arrpos.push(i);
                            }
                        }
                        arrpos.reverse();
                        for (var j = 0; j < arrpos.length; j++) {
                            this.ObjectiveModel.splice(arrpos[j], 1);
                        }

                        this.ObjectiveList.forEach(element => {
                            element.class = 'InterventionByObjWizard';
                            element.classSummary = '';

                            if (!this.ExistObjectiveInGoals(element.goalCode)) {
                                this.ObjectiveModel.push({
                                    goalDescription: element.goalDescription,
                                    goalCode: element.goalCode,
                                    objectives: element.objectives,
                                    selectedCode: (element.selectedCode = []),
                                    selectedDesc: (element.selectedDesc = [])
                                });
                            }

                            this.VisibleObjectives =
                                this.ObjectiveModel.length === 0 ? true : false;
                        });

                        this.OnChangeObjectives();
                        this.Load = false;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        nextClickedTPWiley(currentPage) {
            if (currentPage === 0) {
                if (this.diagCode !== '') {
                    this.getProblemsGroups();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.dSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 1) {
                if (this.Problem !== -1) {
                    this.getWileyTxBehavioralDefinitions();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.proSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 2) {
                if (this.behavioralModel.length > 0) {
                    this.getWileyTxGoals();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.bSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 3) {
                if (this.GoalsModel.length > 0) {
                    this.getWileyTxObjectives();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.gSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 4) {
                if (this.IsSelectedObjectives()) {
                    this.getWileyTxInterventions();
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.oSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 5) {
                if (this.IsSelectedInterventions()) {
                    return true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Warning'),
                        this.$t('treatmentplan.iSelectMsg'),
                        'warning'
                    );
                    return false;
                }
            } else if (currentPage === 6) {
                this.SaveProblem();
                return true;
            }
        },

        getMedTxProblemAggregates() {
            this.Load = true;
            var parameter = {
                ProblemNumber: this.Problem,
                HeaderId: null
            };
            TreatmentPlanService.getMedTxProblemAggregates(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.problemAggregateList = response.data.map(item => ({
                            ...item,
                            model: []
                        }));
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        IsSelectedInterventions() {
            let result = true;
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                for (var j = 0; j < this.InterventionsModel[i].objectives.length; j++) {
                    if (
                        this.InterventionsModel[i].objectives[j].interventionsSelected.length === 0
                    ) {
                        result = false;
                    }
                }
            }
            return result;
        },

        IsSelectedObjectives() {
            //let count = 0;
            let result = true;
            this.ObjectiveModel.forEach(element => {
                // count += element.selectedCode.length;
                if (element.selectedCode.length === 0) {
                    result = false;
                }
            });
            //return count > 0;
            return result;
        },
        EmitSetRowProblem() {
            setTimeout(
                () => this.$refs.RefTableTreatmentProblems.selectRow(this.ProblemIndexSelected),
                300
            );
        },
        EmitSetRowDiagnoses() {
            setTimeout(
                () => this.$refs.RefTableTreatmentDiagnoses.selectRow(this.DiagnoseIndexSelected),
                300
            );
        },
        async SaveProblem() {
            // alert("Saving data, waiting to deploy");
            await this.AddTX();
        },
        backClicked() {
            /*if(currentPage === 2){
              this.EmitSetRowProblem();
              return true;
            }else if(currentPage === 1){
              this.EmitSetRowDiagnoses();
              return true;
            }  */
            return true; //return false if you want to prevent moving to previous page
        },
        GoNext() {
            this.$refs.wizard.goNext(true);
        },
        GoNextDiagnose() {
            this.$refs.wizard.goNext(true);
        },
        onCodeConditionOk(item) {
            if (this.diagCode !== item.code) {
                this.behavioralModel = [];
                this.GoalsModel = [];
                this.ObjectiveModel = [];
                this.InterventionsModel = [];
            }

            if (item.code) {
                this.diagCode = item.code;
                this.diagDesc = item.description;
                this.DiagnoseLabel = 'Diagnosis - ' + this.diagDesc + ' - ' + this.diagCode;
            } else {
                this.diagCode = '';
                this.diagDesc = '';
                this.DiagnoseLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Diagnosis')
                });
            }
        },

        HaveObjectiveEvidenceBased() {
            let count = 0;
            for (var i = 0; i < this.ObjectiveList.length; i++) {
                if (this.ObjectiveList[i].isEvidenceBased) {
                    count++;
                }
            }
            return count > 0;
        },

        HaveSummaryEvidenceBased() {
            let count = 0;
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                if (this.InterventionsModel[i].itvDdescriptionSelected.length > 0) {
                    if (this.InterventionsModel[i].isEvidenceBased) {
                        count++;
                    }
                }
                for (
                    var j = 0;
                    j < this.InterventionsModel[i].itvDdescriptionSelected.length;
                    j++
                ) {
                    if (this.InterventionsModel[i].itvDdescriptionSelected[j].isEvidenceBased) {
                        count++;
                    }
                }
            }
            return count > 0;
        },

        OnChangeProblemMedez(code) {
            for (var i = 0; i < this.itemsProblems.length; i++) {
                if (this.itemsProblems[i].code === code) {
                    this.ProblemD = this.itemsProblems[i].name;
                }
            }
            if (this.Problem !== -1) {
                this.ProblemLabel = 'Problem - ' + this.ProblemD;
            } else {
                this.ProblemLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Problem')
                });
            }

            this.behavioralModel = [];
            this.GoalsModel = [];
            this.ObjectiveModel = [];
            this.InterventionsModel = [];
        },

        OnChangeProblem(code) {
            for (var i = 0; i < this.itemsProblems.length; i++) {
                if (this.itemsProblems[i].problemNumber === code) {
                    this.ProblemD = this.itemsProblems[i].description;
                }
            }
            if (this.Problem !== -1) {
                this.ProblemLabel = 'Problem - ' + this.ProblemD;
            } else {
                this.ProblemLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Problem')
                });
            }

            this.behavioralModel = [];
            this.GoalsModel = [];
            this.ObjectiveModel = [];
            this.InterventionsModel = [];
        },
        GoNextProblem() {
            this.getWileyTxBehavioralDefinitions();
            this.$refs.wizard.goNext(true);
        },
        Save() {},
        onRowClickedDiagnoses(item, index) {
            this.DiagnoseIndexSelected = index;
        },
        onRowClickedProblem(item, index) {
            this.ProblemIndexSelected = index;
        },
        getBehavioralDescriptionByCode(code) {
            for (var i = 0; i < this.BehavioralList.length; i++) {
                if (this.BehavioralList[i].definitionNumber === code) {
                    return this.BehavioralList[i].description;
                }
            }
            return '';
        },
        getGoalsDescriptionByCode(code) {
            for (var i = 0; i < this.GoalsList.length; i++) {
                if (this.GoalsList[i].goalNumber === code) {
                    return this.GoalsList[i].description;
                }
            }
            return '';
        },

        getInteventionDescriptionByCode(arr, code) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].interventionNumber === code) {
                    return arr[i].description;
                }
            }
            return '';
        },

        getObjectiveDescriptionByCode(arr, code) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].objectiveNumber === code) {
                    return arr[i].description;
                }
            }
            return '';
        },

        OnChangeBehavioral(items) {
            if (items.length > 0) {
                this.SelectedBehavioral = [];
                for (var i = 0; i < items.length; i++) {
                    this.SelectedBehavioral.push(this.getBehavioralDescriptionByCode(items[i]));
                }
            } else {
                this.SelectedBehavioral = [];
            }
            if (items.length === 0) {
                this.BehavioralLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('treatmentplan.Behavioral')
                });
            } else if (items.length === 1) {
                this.BehavioralLabel =
                    this.$t('treatmentplan.Behavioral') +
                    '- ' +
                    items.length +
                    ' ' +
                    this.$tc('treatmentplan.iSelected');
            } else {
                this.BehavioralLabel =
                    this.$t('treatmentplan.Behavioral') +
                    '- ' +
                    items.length +
                    ' ' +
                    this.$tc('treatmentplan.iSelected', 2);
            }
        },
        OnChangeGoals(items) {
            if (items.length > 0) {
                this.SelectedGoals = [];
                for (var i = 0; i < items.length; i++) {
                    this.SelectedGoals.push(this.getGoalsDescriptionByCode(items[i]));
                }
            } else {
                this.SelectedGoals = [];
            }
            if (items.length === 0) {
                this.GoalLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('modalAddGoal.goals')
                });
            } else if (items.length === 1) {
                this.GoalLabel =
                    this.$t('modalAddGoal.goals') +
                    '- ' +
                    items.length +
                    ' ' +
                    this.$tc('treatmentplan.iSelected');
            } else {
                this.GoalLabel =
                    this.$t('modalAddGoal.goals') +
                    '- ' +
                    items.length +
                    ' ' +
                    this.$tc('treatmentplan.iSelected', 2);
            }
        },
        OnChangeObjectives() {
            var l = this.ObjectiveModel.length;
            let count = 0;
            for (var i = 0; i < l; i++) {
                count += this.ObjectiveModel[i].selectedCode.length;
                if (this.ObjectiveModel[i].selectedCode.length > 0) {
                    this.ObjectiveModel[i].selectedDesc = [];
                    for (var j = 0; j < this.ObjectiveModel[i].selectedCode.length; j++) {
                        let result = this.getObjSelectedObjective(i, j);
                        this.ObjectiveModel[i].selectedDesc.push({
                            description: this.getObjectiveDescriptionByCode(
                                this.ObjectiveModel[i].objectives,
                                this.ObjectiveModel[i].selectedCode[j]
                            ),
                            class: result.class,
                            isEvidenceBased: result.isEvidenceBased
                        });
                    }
                } else {
                    this.ObjectiveModel[i].selectedDesc = [];
                }
            }

            if (count === 0) {
                this.ObjectiveLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('modalAddObjective.objectives')
                });
            } else if (count === 1) {
                this.ObjectiveLabel =
                    this.$t('modalAddObjective.objectives') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected');
            } else {
                this.ObjectiveLabel =
                    this.$t('modalAddObjective.objectives') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected', 2);
            }
        },

        getObjSelected(i, j, k) {
            let code = this.InterventionsModel[i].objectives[j].interventionsSelected[k];
            let result = { class: '', isEvidenceBased: false };
            for (
                var n = 0;
                n < this.InterventionsModel[i].objectives[j].interventions.length;
                n++
            ) {
                if (
                    this.InterventionsModel[i].objectives[j].interventions[n].interventionNumber ===
                    code
                ) {
                    result.class = this.InterventionsModel[i].objectives[j].interventions[n].class;
                    result.isEvidenceBased = this.InterventionsModel[i].objectives[j].interventions[
                        n
                    ].isEvidenceBased;
                }
            }
            return result;
        },

        getObjSelectedObjective(i, pos) {
            let code = this.ObjectiveModel[i].selectedCode[pos];
            let result = { class: '', isEvidenceBased: false };
            for (var j = 0; j < this.ObjectiveModel[i].objectives.length; j++) {
                if (this.ObjectiveModel[i].objectives[j].objectiveNumber === code) {
                    result.class = this.ObjectiveList[i].objectives[j].class;
                    result.isEvidenceBased = this.ObjectiveList[i].objectives[j].isEvidenceBased;
                }
            }
            return result;
        },

        getObjSelectedMedez(i, j, k) {
            let code = this.InterventionsModel[i].objectives[j].interventionsSelected[k];
            let result = { class: '' };
            for (
                var n = 0;
                n < this.InterventionsModel[i].objectives[j].interventions.length;
                n++
            ) {
                if (this.InterventionsModel[i].objectives[j].interventions[n].code === code) {
                    result.class = this.InterventionsModel[i].objectives[j].interventions[n].class;
                }
            }
            return result;
        },

        getInteventionDescriptionByCodeMedez(arr, code) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].code === code) {
                    return arr[i].description;
                }
            }
            return '';
        },

        OnChangeInterventionsMedez() {
            var l = this.InterventionsModel.length;
            let count = 0;
            for (var i = 0; i < l; i++) {
                for (var j = 0; j < this.InterventionsModel[i].objectives.length; j++) {
                    count += this.InterventionsModel[i].objectives[j].interventionsSelected.length;
                    if (this.InterventionsModel[i].objectives[j].interventionsSelected.length > 0) {
                        this.InterventionsModel[i].objectives[j].itvDdescriptionSelected = [];
                        for (
                            var k = 0;
                            k <
                            this.InterventionsModel[i].objectives[j].interventionsSelected.length;
                            k++
                        ) {
                            let result = this.getObjSelectedMedez(i, j, k);
                            this.InterventionsModel[i].objectives[j].itvDdescriptionSelected.push({
                                description: this.getInteventionDescriptionByCodeMedez(
                                    this.InterventionsModel[i].objectives[j].interventions,
                                    this.InterventionsModel[i].objectives[j].interventionsSelected[
                                        k
                                    ]
                                ),
                                class: result.class
                            });
                        }
                    } else {
                        this.InterventionsModel[i].objectives[j].itvDdescriptionSelected = [];
                    }
                }
            }

            if (count === 0) {
                this.InterventionLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Intervention')
                });
            } else if (count === 1) {
                this.InterventionLabel =
                    this.$t('Shared.Intervention') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected');
            } else {
                this.InterventionLabel =
                    this.$t('Shared.Intervention') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected', 2);
            }
        },

        OnChangeInterventions() {
            var l = this.InterventionsModel.length;
            let count = 0;
            for (var i = 0; i < l; i++) {
                for (var j = 0; j < this.InterventionsModel[i].objectives.length; j++) {
                    count += this.InterventionsModel[i].objectives[j].interventionsSelected.length;
                    if (this.InterventionsModel[i].objectives[j].interventionsSelected.length > 0) {
                        this.InterventionsModel[i].objectives[j].itvDdescriptionSelected = [];
                        for (
                            var k = 0;
                            k <
                            this.InterventionsModel[i].objectives[j].interventionsSelected.length;
                            k++
                        ) {
                            let result = this.getObjSelected(i, j, k);
                            this.InterventionsModel[i].objectives[j].itvDdescriptionSelected.push({
                                description: this.getInteventionDescriptionByCode(
                                    this.InterventionsModel[i].objectives[j].interventions,
                                    this.InterventionsModel[i].objectives[j].interventionsSelected[
                                        k
                                    ]
                                ),
                                class: result.class,
                                isEvidenceBased: result.isEvidenceBased
                            });
                        }
                    } else {
                        this.InterventionsModel[i].objectives[j].itvDdescriptionSelected = [];
                    }
                }
            }

            if (count === 0) {
                this.InterventionLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Intervention')
                });
            } else if (count === 1) {
                this.InterventionLabel =
                    this.$t('Shared.Intervention') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected');
            } else {
                this.InterventionLabel =
                    this.$t('Shared.Intervention') +
                    '- ' +
                    count +
                    ' ' +
                    this.$tc('treatmentplan.iSelected', 2);
            }
        },

        onFilteredDiagnoses() {},
        pageChangedDiagnoses(page) {
            this.currentPageDiagnoses = page;
            this.getDiagTx();
        },
        PerPageFunctionDiagnoses(perpage) {
            this.perPageDiagnoses = perpage;
            this.currentPageDiagnoses = 1;
            this.getDiagTx();
        },
        SearchDiagnoses() {
            this.itemsDiagnoses = [];
            this.currentPageDiagnoses = 1;
            this.parameterDiag.PageNumber = 1;
            this.totalRowsDiagnoses = this.itemsDiagnoses.length;
            this.getDiagTx();
        },
        onRowSelectedProblems(item) {
            if (item.length > 0) {
                this.SelectedProblem = item[0];
                this.ProblemLabel = 'Problem - ' + item[0].description;
            } else {
                this.SelectedProblem = {
                    description: '',
                    problemNumber: '',
                    groupId: 0,
                    customProblem: ''
                };
                this.ProblemLabel = this.$t('treatmentplan.labelSelect', {
                    label: this.$t('Shared.Problem')
                });
            }
        },
        onFilteredProblems() {},
        pageChangedProblems(page) {
            this.currentPageProblems = page;
            this.getWileyTxProblems();
        },
        PerPageFunctionProblems(perpage) {
            this.perPageProblems = perpage;
            this.currentPageProblems = 1;
            this.getWileyTxProblems();
        },

        ChangeProblemGroup(problem) {
            this.behavioralModel = [];
            this.GoalsModel = [];
            this.ObjectiveModel = [];
            this.InterventionsModel = [];
            this.DiagnoseLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Diagnosis')
            });
            this.ProblemLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Problem')
            });
            this.BehavioralLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('treatmentplan.Behavioral')
            });
            this.ObjectiveLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('modalAddObjective.objectives')
            });
            this.InterventionLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Intervention')
            });
            this.GoalLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('modalAddGoal.goals')
            });
            this.Problem = -1;
            this.ProblemLabel = this.$t('treatmentplan.labelSelect', {
                label: this.$t('Shared.Problem')
            });
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                this.InterventionsModel[i].interventionsSelected = [];
                this.InterventionsModel[i].itvDdescriptionSelected = [];
            }
            if (problem !== null && problem !== '') {
                this.ProblemGroupModel = problem;
                this.parameterProb.GroupId = problem.groupId;
                this.getWileyTxProblems();
            } else {
                this.ProblemGroupModel = '';
                this.parameterProb.GroupId = 0;
                this.itemsProblems = [];
            }
        },
        getWileyTxProblems() {
            this.Load = true;
            /* this.parameterProb.PageNumber = this.currentPageProblems;
             this.parameterProb.PageSize = this.perPageProblems;  */
            var parameter = {
                GroupId: this.ProblemGroupModel.groupId,
                AdmissionId: this.AdmissionRecordId,
                NotesId: this.NotesId
                //  NotesId:this.$route.params.notesid
            };
            TreatmentPlanService.getWileyTxProblems(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.itemsProblems = response.data;

                        let headerString = response.headers['x-pagination'];
                        this.HeaderProb = JSON.parse(headerString);
                        this.totalRowsProblems = this.HeaderProb.TotalCount;
                    }
                    /* if (this.itemsProblems.length === 0) {
                    this.ShowMessageIsEmptyProblems = true;
                }*/
                    this.ShowMessageIsEmptyProblems =
                        this.itemsProblems.length === 0 ? true : false;
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },
        getDiagTx() {
            this.Load = true;
            this.parameterDiag.PageNumber = this.currentPageDiagnoses;
            this.parameterDiag.PageSize = this.perPageDiagnoses;
            TreatmentPlanService.getDiagnosestx(this.parameterDiag)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.itemsDiagnoses = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRowsDiagnoses = this.Header.TotalCount;
                    }
                    if (this.itemsDiagnoses.length === 0) {
                        this.ShowMessageIsEmptyDiagnoses = true;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },
        getProblemsGroups() {
            this.Load = true;
            TreatmentPlanService.getWileyTxProblemGroups(this.diagCode)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.ProblemGroupOptions = response.data;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },
        getWileyTxBehavioralDefinitions() {
            this.Load = true;
            var parameter = {
                GroupId: this.ProblemGroupModel.groupId,
                ProblemNumber: this.Problem,
                HeaderId: null
            };
            TreatmentPlanService.getWileyTxBehavioralDefinitions(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.BehavioralList = response.data;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },
        getWileyTxGoals() {
            this.Load = true;
            var parameter = {
                GroupId: this.ProblemGroupModel.groupId,
                ProblemNumber: this.Problem
            };
            TreatmentPlanService.getWileyTxGoals(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.GoalsList = response.data;
                        this.VisibleGoals = this.GoalsList.length === 0 ? true : false;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },
        getWileyTxObjectives() {
            this.Load = true;
            var parameter = {
                IsWizard: true,
                GroupId: this.ProblemGroupModel.groupId,
                ProblemNumber: this.Problem,
                GoalNumberList: this.GoalsModel
            };
            TreatmentPlanService.getWileyTxObjectives(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.ObjectiveList = response.data;

                        let arrpos = [];
                        for (var i = 0; i < this.ObjectiveModel.length; i++) {
                            if (!this.ExistObjetiveinGoalsList(this.ObjectiveModel[i].goalNumber)) {
                                arrpos.push(i);
                            }
                        }
                        arrpos.reverse();
                        for (var j = 0; j < arrpos.length; j++) {
                            this.ObjectiveModel.splice(arrpos[j], 1);
                        }

                        this.ObjectiveList.forEach(element => {
                            element.class = element.isEvidenceBased
                                ? 'InterventionByObjWizard EvidenceBasedTitle'
                                : 'InterventionByObjWizard';
                            element.classSummary = element.isEvidenceBased ? 'EvidenceBased' : '';

                            for (var j = 0; j < element.objectives.length; j++) {
                                element.objectives[j].class = element.objectives[j].isEvidenceBased
                                    ? 'EvidenceBased'
                                    : '';
                            }

                            if (!this.ExistObjectiveInGoals(element.goalNumber)) {
                                this.ObjectiveModel.push({
                                    description: element.description,
                                    goalNumber: element.goalNumber,
                                    objectives: element.objectives,
                                    selectedCode: (element.selectedCode = []),
                                    selectedDesc: (element.selectedDesc = [])
                                });
                            }
                            this.VisibleObjectives =
                                this.ObjectiveModel.length === 0 ? true : false;
                        });

                        this.OnChangeObjectives();
                        this.Load = false;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        EmployeeCodeIsinList(EmpCode) {
            let result = false;
            for (var i = 0; i < this.ProviderList.length; i++) {
                if (this.ProviderList[i].therapistCode === EmpCode) {
                    result = true;
                    break;
                }
            }
            return result;
        },

        getEmployeeProvider() {
            const UserId = LocalStorage.getUserId();
            EmployeeService.getEmployees(UserId)
                .then(response => {
                    if (response.data) {
                        let result = response.data;
                        for (var i = 0; i < result.length; i++) {
                            this.ProviderList.push({
                                therapistCode: result[i].code,
                                therapistName: result[i].name
                            });
                        }

                        if (this.EmployeeCodeIsinList(this.EmployeeCode)) {
                            this.ProviderModel.therapistCode = this.EmployeeCode;
                            this.ProviderModel.therapistName = LocalStorage.getName();
                        }
                    }
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        getEmployeeCoProvider() {
            EmployeeService.getEmployeeLookup({ Cosigner: true })
                .then(response => {
                    if (response.data) {
                        this.CoProviderList = response.data.map(element => ({
                            coTherapistCode: element.code,
                            coTherapistName: element.description
                        }));
                        /*let result = response.data;
                        for (var i = 0; i < result.length; i++) {
                            this.CoProviderList.push({
                                coTherapistCode: result[i].code,
                                coTherapistName: result[i].name
                            });
                        }*/
                    }
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        ExistObjectiveInGoals(objGoal) {
            var l = this.ObjectiveModel.length;
            for (var i = 0; i < l; i++) {
                if (this.ObjectiveModel[i].goalNumber === objGoal) {
                    return true;
                }
            }
            return false;
        },

        ExistGoal(goalNumber) {
            var l = this.InterventionsModel.length;
            for (var i = 0; i < l; i++) {
                if (this.InterventionsModel[i].goalNumber === goalNumber) {
                    return true;
                }
            }
            return false;
        },
        ExistObjetiveinInterventionsList(ObjNumber) {
            let result = false;
            var l = this.ObjectiveModel.length;
            for (var i = 0; i < l; i++) {
                for (var j = 0; j < this.ObjectiveModel[i].selectedCode.length; j++) {
                    if (this.ObjectiveModel[i].selectedCode[j] === ObjNumber) {
                        result = true;
                    }
                }
                /*if (this.ObjectiveModel[i] === ObjNumber) {
                    return true;
                }*/
            }
            return result;
        },

        ExistObjetiveinGoalsList(ObjGoal) {
            var l = this.GoalsModel.length;
            for (var i = 0; i < l; i++) {
                if (this.GoalsModel[i] === ObjGoal) {
                    return true;
                }
            }
            return false;
        },

        PopulateListRequestIntervention() {
            this.GoalNumberList = [];
            this.ObjectiveNumberList = [];
            this.ObjectiveModel.forEach(element => {
                if (element.selectedCode.length > 0) {
                    for (var i = 0; i < element.selectedCode.length; i++) {
                        this.GoalNumberList.push(element.goalNumber);
                        this.ObjectiveNumberList.push(element.selectedCode[i]);
                    }
                }
            });
        },

        PopulateListRequestInterventionMedez() {
            this.GoalCodeList = [];
            this.ObjectiveCodeList = [];
            this.ObjectiveModel.forEach(element => {
                if (element.selectedCode.length > 0) {
                    for (var i = 0; i < element.selectedCode.length; i++) {
                        this.GoalCodeList.push(element.goalCode);
                        this.ObjectiveCodeList.push(element.selectedCode[i]);
                    }
                }
            });
        },

        ExistGoalinIntervention(goalNumber) {
            var arr = this.GoalsModel;
            let l = arr.length;
            for (var i = 0; i < l; i++) {
                if (arr[i] === goalNumber) {
                    return true;
                }
            }
            return false;
        },

        RemoveEmptyObjective() {
            var arrGoals = [];
            for (var j = 0; j < this.InterventionsModel.length; j++) {
                if (this.InterventionsModel[j].objectives.length == 0) {
                    arrGoals.push(this.InterventionsModel[j].goalNumber);
                }
            }
            var temp = [];
            for (var i = 0; i < arrGoals.length; i++) {
                temp = this.InterventionsModel.filter(item => item.goalNumber !== arrGoals[i]);
            }
            this.InterventionsModel = temp.length > 0 ? temp : this.InterventionsModel;
        },

        IsIntInGoals(goalNumber) {
            for (var j = 0; j < this.GoalsModel.length; j++) {
                if (this.GoalsModel[j] === goalNumber) {
                    return true;
                }
            }
            return false;
        },

        IsIntInGoalsMedez(goalCode) {
            for (var j = 0; j < this.GoalsModel.length; j++) {
                if (this.GoalsModel[j] === goalCode) {
                    return true;
                }
            }
            return false;
        },

        RemoveGoalNotChecked() {
            let arrtemp = [];
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                if (this.IsIntInGoals(this.InterventionsModel[i].goalNumber)) {
                    arrtemp.push(this.InterventionsModel[i]);
                }
            }

            this.InterventionsModel = arrtemp.length > 0 ? arrtemp : this.InterventionsModel;
        },

        RemoveGoalNotCheckedMedez() {
            let arrtemp = [];
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                if (this.IsIntInGoalsMedez(this.InterventionsModel[i].goalCode)) {
                    arrtemp.push(this.InterventionsModel[i]);
                }
            }

            this.InterventionsModel = arrtemp.length > 0 ? arrtemp : this.InterventionsModel;
        },

        IsIntInObjectives(goalNumber, objectiveNumber) {
            var objectives = this.ObjectiveModel.filter(item => item.goalNumber === goalNumber);
            if (objectives.length > 0) {
                var codes = objectives[0].selectedCode;
                for (var i = 0; i < codes.length; i++) {
                    if (codes[i] === objectiveNumber) return true;
                }
            }
            return false;
        },

        FindObjectiveInintevList(goalNumber, objNumber) {
            var itv = this.InterventionsList.filter(item => item.goalNumber === goalNumber);
            var objtemp = {};
            if (itv.length > 0) {
                let itvtmp = itv[0];
                for (var i = 0; i < itvtmp.objectives.length; i++) {
                    if (itvtmp.objectives[i].objectiveNumber === objNumber) {
                        objtemp = itvtmp.objectives[i];
                    }
                }
            }

            return objtemp;
        },

        AddObj(goalNumber, obj) {
            if (obj !== null) {
                for (var i = 0; i < this.InterventionsModel.length; i++) {
                    if (this.InterventionsModel[i].goalNumber === goalNumber) {
                        this.InterventionsModel[i].objectives.push(obj);
                    }
                }
            }
        },

        ObjectiveIsInInterv(goalNumber, objNumber) {
            var objectives = this.InterventionsModel.filter(item => item.goalNumber === goalNumber);
            if (objectives.length > 0) {
                var objs = objectives[0].objectives;
                for (var i = 0; i < objs.length; i++) {
                    if (objs[i].objectiveNumber === objNumber) return true;
                }
            }
            return false;
        },

        AddNewObjectives() {
            for (var i = 0; i < this.ObjectiveModel.length; i++) {
                for (var j = 0; j < this.ObjectiveModel[i].selectedCode.length; j++) {
                    if (
                        !this.ObjectiveIsInInterv(
                            this.ObjectiveModel[i].goalNumber,
                            this.ObjectiveModel[i].selectedCode[j]
                        )
                    ) {
                        var obj = this.FindObjectiveInintevList(
                            this.ObjectiveModel[i].goalNumber,
                            this.ObjectiveModel[i].selectedCode[j]
                        );
                        if (obj !== null) {
                            this.AddObj(this.ObjectiveModel[i].goalNumber, obj);
                        }
                    }
                }
            }
        },

        RemoveObjectiveNotChecked() {
            let arrtemp = [];
            let arrposdelete = [];
            for (var i = 0; i < this.InterventionsModel.length; i++) {
                for (var j = 0; j < this.InterventionsModel[i].objectives.length; j++) {
                    if (
                        this.IsIntInObjectives(
                            this.InterventionsModel[i].goalNumber,
                            this.InterventionsModel[i].objectives[j].objectiveNumber
                        )
                    ) {
                        arrtemp.push(this.InterventionsModel[i].objectives[j]);
                    } else {
                        arrposdelete.push({ goalpos: i, objectivepos: j });
                    }
                }
                this.InterventionsModel[i].objectives =
                    arrtemp.length > 0 ? arrtemp : this.InterventionsModel[i].objectives;
                arrposdelete.reverse();
                for (var k = 0; k < arrposdelete.length; k++) {
                    this.InterventionsModel[arrposdelete[k].goalpos].objectives.splice(
                        arrposdelete[k].objectivepos,
                        1
                    );
                }
                arrtemp = [];
                arrposdelete = [];
            }
        },

        getWileyTxInterventions() {
            this.PopulateListRequestIntervention();
            this.Load = true;
            var parameter = {
                GroupId: this.ProblemGroupModel.groupId,
                ProblemNumber: this.Problem,
                GoalNumberList: this.GoalNumberList,
                ObjectiveNumberList: this.ObjectiveNumberList,
                IsWizard: true
            };
            TreatmentPlanService.getWileyTxInterventions(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.InterventionsList = response.data;

                        this.InterventionsList.forEach(element => {
                            for (var i = 0; i < element.objectives.length; i++) {
                                element.objectives[i].class = element.objectives[i].isEvidenceBased
                                    ? 'InterventionByObjWizard EvidenceBasedTitle'
                                    : 'InterventionByObjWizard';
                                element.objectives[i].classSummary = element.objectives[i]
                                    .isEvidenceBased
                                    ? 'EvidenceBased'
                                    : '';
                                element.objectives[i].interventionsSelected = element.objectives[
                                    i
                                ].interventionsSelected = [];
                                element.objectives[i].itvDdescriptionSelected = element.objectives[
                                    i
                                ].itvDdescriptionSelected = [];

                                for (
                                    var j = 0;
                                    j < element.objectives[i].interventions.length;
                                    j++
                                ) {
                                    element.objectives[i].interventions[j].class = element
                                        .objectives[i].interventions[j].isEvidenceBased
                                        ? 'EvidenceBased'
                                        : '';
                                }
                            }

                            if (!this.ExistGoal(element.goalNumber)) {
                                this.InterventionsModel.push({
                                    goalNumber: element.goalNumber,
                                    description: element.description,
                                    objectives: element.objectives
                                });
                            }
                            this.VisibleIntervention =
                                this.InterventionsModel.length === 0 ? true : false;
                        });

                        this.RemoveGoalNotChecked();
                        this.RemoveObjectiveNotChecked();
                        this.AddNewObjectives();
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        AddProblem() {
            //  if(this.TreatmentPlanType === "TfmWileyTreatmentPlanNotes"){
            //
            this.isEditMode = false;
            this.isAddwlTP = true;
            // }
        },

        getMedTxProblems() {
            this.Load = true;
            var parameter = {
                AdmissionId: this.AdmissionRecordId,
                NotesId: this.NotesId
            };
            TreatmentPlanService.getMedTxProblems(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.itemsProblems = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.HeaderProb = JSON.parse(headerString);
                        this.totalRowsProblems = this.HeaderProb.TotalCount;
                    }
                    this.ShowMessageIsEmptyProblems =
                        this.itemsProblems.length === 0 ? true : false;
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        AddProblemMedez() {
            this.TreatmentPlanType = '';
            this.isAddMdTP = true;
            this.getMedTxProblems();
            /* const handleWindowResize = () => setWidth(window.innerWidth);
     window.addEventListener('resize', handleWindowResize);*/
            //   window.resizeTo(window.screen.availWidth, window.screen.availHeight);
        },

        AddProblemWiley() {
            this.TreatmentPlanType = '';
            this.isAddwlTP = true;
        },

        SearchProblems() {
            this.getProblems();
        },

        ModalTPAddSignature() {
            this.VisibleAddSignature = false;
        },

        ModalTPAddSignatureWiley() {
            this.VisibleAddSignatureWiley = false;
        },
        ModalTPAddSignatureMedez() {
            this.VisibleAddSignatureMedez = false;
        },

        OpenModalBlankBehavioral(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleBlankTPBehavioral = true;
        },

        OpenModalBlankBehavioralWiley(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleBlankTPBehavioralWiley = true;
        },

        OpenModalBlankBehavioralMedez(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleBlankTPBehavioralMedez = true;
        },

        PrintProblem(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.isProblemRepVisible = true;
        },

        OnEditTPProblemCancel() {
            this.VisibleEditTPProblem = false;
        },

        OnEditTPProblemCancelMedez() {
            this.VisibleEditTPProblemMedez = false;
        },

        OnEditTPProblemCancelWiley() {
            this.VisibleEditTPProblemWiley = false;
        },

        OpenModal(item) {
            this.ProbDesc = item.problem.probDesc;
            this.DiagDesc = item.problem.dsm5description;
            this.DiagCode = item.problem.dsm5;
            this.ProblemDateIdentified = item.problem.probDate;
            this.ProblemRecId = item.problem.probRecId;
            this.VisibleEditTPProblem = true;
        },

        OpenModalWiley(item) {
            this.ProbDesc = item.problem.probDesc;
            this.DiagDesc = item.problem.dsm5description;
            this.DiagCode = item.problem.dsm5;
            this.ProblemDateIdentified = item.problem.probDate;
            this.ProblemRecId = item.problem.probRecId;
            this.VisibleEditTPProblemWiley = true;
        },

        OpenModalMedez(item) {
            this.ProbDesc = item.problem.probDesc;
            this.DiagDesc = item.problem.dsm5description;
            this.DiagCode = item.problem.dsm5;
            this.ProblemDateIdentified = item.problem.probDate;
            this.ProblemRecId = item.problem.probRecId;
            this.VisibleEditTPProblemMedez = true;
        },

        RefreshGetTP() {
            this.VisibleEditTPBehavioral = false;
            this.VisibleEditTPBehavioralWiley = false;
            this.VisibleEditTPBehavioralMedez = false;
            this.VisibleEditTPProblem = false;
            this.VisibleBlankTPBehavioral = false;
            this.VisibleAddGoals = false;
            this.VisibleAddGoalsWiley = false;
            this.VisibleAddGoalsMedez = false;
            this.VisibleAddObjetive = false;
            this.VisibleEditGoal = false;
            this.VisibleAddIntervention = false;
            this.VisibleEditObjective = false;
            this.VisibleEditIntervention = false;
            this.VisibleAddSignature = false;
            this.showModalSignature = false;
            this.VisibleAddObjetiveMedez = false;
            this.VisibleEditGoalMedez = false;
            this.VisibleAddInterventionMedez = false;
            this.VisibleEditObjectiveMedez = false;
            this.VisibleEditInterventionMedez = false;
            this.VisibleAddSignatureMedez = false;
            this.VisibleEditTPProblemMedez = false;
            this.showModalSignatureMedez = false;
            this.showModalSignatureWiley = false;
            this.VisibleEditTPProblemWiley = false;
            this.VisibleBlankTPBehavioralWiley = false;
            this.VisibleAddObjetiveWiley = false;
            this.VisibleEditGoalWiley = false;
            this.VisibleAddInterventionWiley = false;
            this.VisibleEditObjectiveWiley = false;
            this.VisibleEditInterventionWiley = false;
            this.VisibleAddSignatureWiley = false;

            this.getProblems();
        },

        GotoTPOutComeList() {
            this.showListing(true);
            this.TreatmentPlanType = '';
            this.isAddwlTP = false;
            this.isAddMdTP = false;
            this.itemsProblems = [];
        },

        ModalTPBlankBehavioralCANCEL() {
            this.VisibleBlankTPBehavioral = false;
        },

        ModalTPBlankBehavioralCANCELWiley() {
            this.VisibleBlankTPBehavioralWiley = false;
        },

        CopyProblemDefinitions(arr) {
            let temp = [];

            for (var i = 0; i < arr.length; i++) {
                temp.push({ ...arr[i] });
            }

            return temp;
        },

        ModalTPEditGoal() {
            this.VisibleEditGoal = false;
        },

        ModalTPEditGoalMedez() {
            this.VisibleEditGoalMedez = false;
        },

        ModalTPEditGoalWiley() {
            this.VisibleEditGoalWiley = false;
        },

        onModalPasswordResultSuperVisor(result) {
            if (result.Event === 'Ok') {
                if (result.status === true) {
                    this.Load = true;
                    TreatmentPlan.deleteSignature(this.SignatureId, this.HeaderId, this.NotesId)
                        .then(response => {
                            if (response.status == '200') {
                                this.RefreshGetTP();
                                setTimeout(
                                    () =>
                                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: 'success'
                                        }),
                                    5
                                );
                            }
                            this.Load = false;
                        })
                        .catch(error => {
                            this.Load = false;
                            if (!error.response) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.retrieveInfo'),
                                    'error'
                                );
                            } else if (error.response.status === 400) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            } else if (error.response.status === 500) {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('Msg.ThereWereSomeError'),
                                    'error'
                                );
                            } else {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    error.response.data.errorMessage,
                                    'error'
                                );
                            }
                        });
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.InvalidSupervisorPass'),
                        'error'
                    );
                }
            }
            this.showSignPasswordSuperVisor = false;
        },

        DeleteSignature(s) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_tp_signature'
                })
                .then(value => {
                    if (value) {
                        this.SignatureId = s.signatureRecId;
                        this.showSignPasswordSuperVisor = true;
                        /* TreatmentPlan.deleteSignature(s.signatureRecId,this.HeaderId,this.NotesId)
              .then((response) => {
                if (response.status == '200') {
                  this.RefreshGetTP();
                  setTimeout(() =>
                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                      title: this.$t('Msg.Saving'),
                      autoHideDelay: 5000,
                      variant: "success"
                    })
                    , 5);
                }
               this.Load = false;
              })
              .catch(error => {
                this.Load = false;
                if (!error.response) {
                  this.showMessage(this.$t('modalAddSignature.sign', {'label': this.$t('Shared.TitleDelete')}), this.$t('Msg.retrieveInfo'), "error");
                }
                else if (error.response.status === 400) {
                  this.showMessage(this.$t('modalAddSignature.sign', {'label': this.$t('Shared.TitleDelete')}), error.response.data.errorMessage, "error");
                }
                else if (error.response.status === 500) {
                  this.showMessage(this.$t('modalAddSignature.sign', {'label': this.$t('Shared.TitleDelete')}), this.$t('Msg.ThereWereSomeError'), "error");
                }
                else {
                  this.showMessage(this.$t('modalAddSignature.sign', {'label': this.$t('Shared.TitleDelete')}), error.response.data.errorMessage, "error");
                }
              });*/
                    }
                });
        },

        DeleteGoal(g) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_tp_Goal'
                })
                .then(value => {
                    if (value) {
                        this.Load = true;
                        TreatmentPlan.deleteGoal(g.goal.goalRecId)
                            .then(response => {
                                if (response.status == '200') {
                                    this.RefreshGetTP();
                                    setTimeout(
                                        () =>
                                            this.$bvToast.toast(
                                                this.$t('treatmentplan.DeleteGoal'),
                                                {
                                                    title: this.$t('Msg.Saving'),
                                                    autoHideDelay: 5000,
                                                    variant: 'success'
                                                }
                                            ),
                                        5
                                    );
                                }
                                this.Load = false;
                            })
                            .catch(error => {
                                this.Load = false;
                                if (!error.response) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelGolaTT'),
                                        this.$t('Msg.retrieveInfo'),
                                        'error'
                                    );
                                } else if (error.response.status === 400) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelGolaTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                } else if (error.response.status === 500) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelGolaTT'),
                                        this.$t('Msg.ThereWereSomeError'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelGolaTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                }
                            });
                    }
                });
        },

        DeleteIntervention(i) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_tp_Intervention'
                })
                .then(value => {
                    if (value) {
                        TreatmentPlan.deleteIntervention(i.intRecId)
                            .then(response => {
                                if (response.status == '200') {
                                    this.RefreshGetTP();
                                    setTimeout(
                                        () =>
                                            this.$bvToast.toast(
                                                this.$t('treatmentplan.DeleteIntervention'),
                                                {
                                                    title: this.$t('Msg.Saving'),
                                                    autoHideDelay: 5000,
                                                    variant: 'success'
                                                }
                                            ),
                                        5
                                    );
                                }
                                this.Load = false;
                            })
                            .catch(error => {
                                this.Load = false;
                                if (!error.response) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelIntTT'),
                                        this.$t('Msg.retrieveInfo'),
                                        'error'
                                    );
                                } else if (error.response.status === 400) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelIntTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                } else if (error.response.status === 500) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelIntTT'),
                                        this.$t('Msg.ThereWereSomeError'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelIntTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                }
                            });
                    }
                });
        },

        ModalTPAddIntervention() {
            this.VisibleAddIntervention = false;
        },
        ModalTPAddInterventionWiley() {
            this.VisibleAddInterventionWiley = false;
        },
        ModalTPAddInterventionMedez() {
            this.VisibleAddInterventionMedez = false;
        },

        OnReturnSignatureCancel() {
            this.showModalSignature = false;
        },

        OnReturnSignatureCancelMedez() {
            this.showModalSignatureMedez = false;
        },

        OnReturnSignatureCancelWiley() {
            this.showModalSignatureWiley = false;
        },

        EditSignature(s) {
            s.ModelClient = { code: '', name: '' };
            s.ModelClientCheck = false;
            if (s.isPatientSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientSigned',
                    name: this.$t('modalAddSignature.pSigned')
                };
            }

            if (s.refuseSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientRefused',
                    name: this.$t('modalAddSignature.pRefused')
                };
            }

            if (s.guardianSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'GuardianSigned',
                    name: this.$t('modalAddSignature.gSigned')
                };
            }
            this.SignatureEdit = { ...s };
            this.showModalSignature = true;
        },

        EditSignatureMedez(s) {
            s.ModelClient = { code: '', name: '' };
            s.ModelClientCheck = false;
            if (s.isPatientSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientSigned',
                    name: this.$t('modalAddSignature.pSigned')
                };
            }

            if (s.refuseSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientRefused',
                    name: this.$t('modalAddSignature.pRefused')
                };
            }

            if (s.guardianSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'GuardianSigned',
                    name: this.$t('modalAddSignature.gSigned')
                };
            }
            this.SignatureEdit = { ...s };
            this.showModalSignatureMedez = true;
        },

        EditSignatureWiley(s) {
            s.ModelClient = { code: '', name: '' };
            s.ModelClientCheck = false;
            if (s.isPatientSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientSigned',
                    name: this.$t('modalAddSignature.pSigned')
                };
            }

            if (s.refuseSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'PatientRefused',
                    name: this.$t('modalAddSignature.pRefused')
                };
            }

            if (s.guardianSigned) {
                s.ModelClientCheck = true;
                s.ModelClient = {
                    code: 'GuardianSigned',
                    name: this.$t('modalAddSignature.gSigned')
                };
            }
            this.SignatureEdit = { ...s };
            this.showModalSignatureWiley = true;
        },

        PrintObjective(o) {
            this.ObjRecId = o.objective.objRecId;
            this.isObjectiveRepVisible = true;
        },

        DeleteObjective(o) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_tp_Objective'
                })
                .then(value => {
                    if (value) {
                        this.Load = true;
                        TreatmentPlan.deleteObjective(o.objective.objRecId)
                            .then(response => {
                                if (response.status == '200') {
                                    this.RefreshGetTP();
                                    setTimeout(
                                        () =>
                                            this.$bvToast.toast(
                                                this.$t('treatmentplan.DeleteObjective'),
                                                {
                                                    title: this.$t('Msg.Saving'),
                                                    autoHideDelay: 5000,
                                                    variant: 'success'
                                                }
                                            ),
                                        5
                                    );
                                }
                                this.Load = false;
                            })
                            .catch(error => {
                                this.Load = false;
                                if (!error.response) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelObjTT'),
                                        this.$t('Msg.retrieveInfo'),
                                        'error'
                                    );
                                } else if (error.response.status === 400) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelObjTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                } else if (error.response.status === 500) {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelObjTT'),
                                        this.$t('Msg.ThereWereSomeError'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(
                                        this.$t('modalEditProblem.DelObjTT'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                }
                            });
                    }
                });
        },

        ModalTPEditObjective() {
            this.VisibleEditObjective = false;
        },
        ModalTPEditObjectiveWiley() {
            this.VisibleEditObjectiveWiley = false;
        },
        ModalTPEditObjectiveMedez() {
            this.VisibleEditObjectiveMedez = false;
        },

        OpenModalEditObjective(item, o) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.ObjectiveEdit.objRecId = o.objective.objRecId;
            this.ObjectiveEdit.objCode = o.objective.objCode;
            this.ObjectiveEdit.dateIdentified = o.objective.dateSet;
            this.ObjectiveEdit.dateExpected = o.objective.dateExp;
            this.ObjectiveEdit.dateAchieve = o.objective.dateAchieve;
            this.ObjectiveEdit.status = {
                code: o.objective.status,
                description: o.objective.status
            };
            this.ObjectiveEdit.description = o.objective.objDesc;

            this.VisibleEditObjective = true;
        },

        OpenModalEditObjectiveMedez(item, o) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.ObjectiveEdit.objRecId = o.objective.objRecId;
            this.ObjectiveEdit.objCode = o.objective.objCode;
            this.ObjectiveEdit.dateIdentified = o.objective.dateSet;
            this.ObjectiveEdit.dateExpected = o.objective.dateExp;
            this.ObjectiveEdit.dateAchieve = o.objective.dateAchieve;
            this.ObjectiveEdit.status = {
                code: o.objective.status,
                description: o.objective.status
            };
            this.ObjectiveEdit.description = o.objective.objDesc;

            this.VisibleEditObjectiveMedez = true;
        },

        OpenModalEditObjectiveWiley(item, o) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.ObjectiveEdit.objRecId = o.objective.objRecId;
            this.ObjectiveEdit.objCode = o.objective.objCode;
            this.ObjectiveEdit.dateIdentified = o.objective.dateSet;
            this.ObjectiveEdit.dateExpected = o.objective.dateExp;
            this.ObjectiveEdit.dateAchieve = o.objective.dateAchieve;
            this.ObjectiveEdit.status = {
                code: o.objective.status,
                description: o.objective.status
            };
            this.ObjectiveEdit.description = o.objective.objDesc;

            this.VisibleEditObjectiveWiley = true;
        },

        OpenModalAddIntervention(item, g, o) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ObjectiveListObj = [];
            this.ObjectiveListObj.push(o.objective.objCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.ObjRecId = o.objective.objRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddIntervention = true;
        },

        OpenModalAddInterventionMedez(item, g, o) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ObjectiveListObj = [];
            this.ObjectiveListObj.push(o.objective.objCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.ObjRecId = o.objective.objRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddInterventionMedez = true;
        },

        OpenModalAddInterventionWiley(item, g, o) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ObjectiveListObj = [];
            this.ObjectiveListObj.push(o.objective.objCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.ObjRecId = o.objective.objRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddInterventionWiley = true;
        },

        OpenModalEditGoal(item, g) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.GoalEdit.goalRecId = g.goal.goalRecId;
            this.GoalEdit.goalCode = g.goal.goalCode;
            this.GoalEdit.dateIdentified = g.goal.dateSet;
            this.GoalEdit.dateExpected = g.goal.dateExp;
            this.GoalEdit.dateAchieve = g.goal.dateAchieve;
            this.GoalEdit.status = g.goal.statusobj;
            this.GoalEdit.description = g.goal.goalDesc;

            this.VisibleEditGoal = true;
        },

        OpenModalEditGoalMedez(item, g) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.GoalEdit.goalRecId = g.goal.goalRecId;
            this.GoalEdit.goalCode = g.goal.goalCode;
            this.GoalEdit.dateIdentified = g.goal.dateSet;
            this.GoalEdit.dateExpected = g.goal.dateExp;
            this.GoalEdit.dateAchieve = g.goal.dateAchieve;
            this.GoalEdit.status = g.goal.statusobj;
            this.GoalEdit.description = g.goal.goalDesc;
            this.VisibleEditGoalMedez = true;
        },

        OpenModalEditGoalWiley(item, g) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.GoalEdit.goalRecId = g.goal.goalRecId;
            this.GoalEdit.goalCode = g.goal.goalCode;
            this.GoalEdit.dateIdentified = g.goal.dateSet;
            this.GoalEdit.dateExpected = g.goal.dateExp;
            this.GoalEdit.dateAchieve = g.goal.dateAchieve;
            this.GoalEdit.status = g.goal.statusobj;
            this.GoalEdit.description = g.goal.goalDesc;
            this.VisibleEditGoalWiley = true;
        },

        ModalTPGoalCANCEL() {
            this.VisibleAddGoals = false;
        },

        ModalTPGoalCANCELWiley() {
            this.VisibleAddGoalsWiley = false;
        },

        ModalTPGoalCANCELMedez() {
            this.VisibleAddGoalsMedez = false;
        },

        OpenModalAddObjective(item, g) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddObjetive = true;
        },

        OpenModalGoal(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddGoals = true;
        },

        OpenModalGoalMedez(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddGoalsMedez = true;
        },

        OpenModalGoalWiley(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddGoalsWiley = true;
        },

        /*OpenModalAddObjective(item, g) {     
      this.GoalListObj = [];
      this.GoalListObj.push(g.goal.goalCode);
      this.ProblemRecId = item.problem.probRecId;
      this.GoalRecId = g.goal.goalRecId;
      this.groupId = item.problem.groupId;
      this.headerId = item.problem.headerId;
      this.probCode = item.problem.probCode;
      this.VisibleAddObjetive = true;
    },*/

        OpenModalAddObjectiveMedez(item, g) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddObjetiveMedez = true;
        },

        ModalTPObjectiveCANCEL() {
            this.VisibleAddObjetive = false;
        },

        ModalTPObjectiveCANCELWiley() {
            this.VisibleAddObjetiveWiley = false;
        },

        ModalTPObjectiveCANCELMedez() {
            this.VisibleAddObjetiveMedez = false;
        },

        OpenModalAddObjectiveWiley(item, g) {
            this.GoalListObj = [];
            this.GoalListObj.push(g.goal.goalCode);
            this.ProblemRecId = item.problem.probRecId;
            this.GoalRecId = g.goal.goalRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleAddObjetiveWiley = true;
        },

        ModalTPEditBehavioralCANCEL() {
            this.VisibleEditTPBehavioral = false;
        },

        ModalTPEditBehavioralCANCELWiley() {
            this.VisibleEditTPBehavioralWiley = false;
        },

        ModalTPEditBehavioralCANCELMedez() {
            this.VisibleEditTPBehavioralMedez = false;
        },

        OpenModalBehavioralWiley(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.BehavioralsModal = this.CopyProblemDefinitions(item.problemDefinitions); // item.problemDefinitions;
            this.VisibleEditTPBehavioralWiley = true;
        },

        OpenModalBehavioralMedez(item) {
            this.ItemSelected = item.problemAggregates;
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.BehavioralsModal = this.CopyProblemDefinitions(item.problemDefinitions); // item.problemDefinitions;
            this.VisibleEditTPBehavioralMedez = true;
        },

        PrintOnlyProblem(item) {
            this.ProblemRecId = item.problem.probRecId;
            this.isTreatmentPlanProblemRepVisible = true;
        },

        closeParamRepWindow() {
            this.isReportVisible = false;
            this.isObjectiveRepVisible = false;
            this.isProblemRepVisible = false;
            this.isTreatmentPlanProblemRepVisible = false;
        },

        showListing(show) {
            this.isEditMode = show ? false : true;
            this.isListing = show ? true : false;
        },

        ResetProps() {
            this.parameter.SearchCriteria = '';
            this.showListing(true);
        },

        ChangeDropDownVersions(item) {
            this.VersionModel = item ? item.toString() : { code: '0', description: 'Current' };
            // this.Load = true;
            this.getProblems();
            // this.getNotesHeader(this.VersionModel.code);
            //  this.getControlsAndValues(this.VersionModel.code);

            if (this.VersionModel.code > 0) {
                // this.NoteIsReadOnly = true;
                this.isReadOnly = true;
            } else {
                //this.NoteIsReadOnly = false;
                this.isReadOnly = false;
            }
            //this.showPrint = true;
        },

        emitEventOK() {
            this.clickOK = true;
            this.$emit('TreatmentPlanCompleted');
            this.$emit('getCancel');
        },

        emitEventHide() {
            this.$emit('getCancel');
        },

        AddSignature() {
            this.headerId = this.TreatmentPlan.problems[0].problem.headerId;
            this.VisibleAddSignature = true;
        },

        AddSignatureWiley() {
            this.headerId = this.TreatmentPlan.problems[0].problem.headerId;
            this.VisibleAddSignatureWiley = true;
        },

        AddSignatureMedez() {
            this.headerId = this.TreatmentPlan.problems[0].problem.headerId;
            this.VisibleAddSignatureMedez = true;
        },

        showReport() {
            this.isReportVisible = true;
        },

        VoidClick() {
            this.Load = true;
            let data = {
                notesId: this.NotesId
            };
            TreatmentPlan.VoidTP(this.HeaderId, data)
                .then(response => {
                    this.Load = false;
                    if (response.status == '200') {
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('treatmentplan.tPlanVoidmsg'), {
                                    title: this.$t('Msg.Saving'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            30
                        );
                        this.getProblems();
                    }
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$t('treatmentplan.tPlanVoid'),
                            this.$t('Msg.NotAbleToUpdate'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$t('treatmentplan.tPlanVoid'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$t('treatmentplan.tPlanVoid'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$t('treatmentplan.tPlanVoid'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        async getProblems() {
            this.Load = true;
            let additionalInfo = {};
            if (!this.isOpenInEmployeeInbox) {
                additionalInfo = {
                    FormId: this.HeaderObj.notesId,
                    PatientCode: this.HeaderObj.patientCode,
                    HeaderId: this.HeaderObj.Id,
                    TransDate: this.HeaderObj.transDate,
                    AdmissionRecordId: this.AdmissionRecordId,
                    GroupNodeHeaderId: this.HeaderObj.GroupNodeHeaderId,
                    groupCreationId: this.HeaderObj.groupCreationId,
                    noteStatus: this.HeaderObj.noteStatus,
                    recordid: this.HeaderObj.recordid,
                    therapistCode: this.HeaderObj.therapistCode
                };
            }

            let viewLog = this.isOpenInEmployeeInbox ? false : true;
            await TreatmentPlan.getProblemsByAdmId(
                this.AdmissionRecordId,
                this.NotesId,
                this.VersionModel.code,
                this.parameter.SearchCriteria,
                null,
                additionalInfo,
                viewLog
            )
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.TreatmentPlan = response.data;

                        if (this.TreatmentPlan.problems.length > 0) {
                            this.HeaderId = this.TreatmentPlan.problems[0].problem.headerId;

                            if (
                                this.NoteOptions.enableNoteVersioning &&
                                this.NoteOptions.showVersioOnlyForSupervisors
                            ) {
                                if (this.isSupervisor) {
                                    this.getVersions();
                                } else {
                                    this.VisibleVersion = false;
                                }
                            } else if (
                                this.NoteOptions.enableNoteVersioning &&
                                !this.NoteOptions.showVersioOnlyForSupervisors
                            ) {
                                this.getVersions();
                            } else {
                                this.VisibleVersion = false;
                            }
                        }

                        for (var i = 0; i < this.TreatmentPlan.signatures.length; i++) {
                            this.TreatmentPlan.signatures[i].disabledCheckClient = false;
                        }

                        this.VisibleSignature =
                            this.TreatmentPlan.problems.length > 0 ? true : false;
                        this.FormatTreatmentPlanDates(this.TreatmentPlan);

                        if (this.parameter.SearchCriteria.trim() === '') {
                            this.VisibleNoRecordsWithFilter = false;
                            this.VisibleNoRecords =
                                this.TreatmentPlan.problems.length > 0 ? false : true;
                        } else {
                            this.VisibleNoRecords = false;
                            this.VisibleNoRecordsWithFilter =
                                this.TreatmentPlan.problems.length > 0 ? false : true;
                        }
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$t('Shared.treatmentplan'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$t('Shared.treatmentplan'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$t('Shared.treatmentplan'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$t('Shared.treatmentplan'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        getTextResult() {
            let textResult = '';
            let keys = [];
            if (this.selected.length > 0) {
                var item = this.selected[0];
                keys = Object.keys(this.items[0]);
                keys.forEach(element => {
                    if (item[element] != '' && item[element] != '0' && item[element] != null) {
                        if (
                            element != 'therapistCode' &&
                            element != 'recNo' &&
                            element != 'notes' &&
                            element != 'bmi' &&
                            element != 'bsa' &&
                            element != 'o2inhaled'
                        ) {
                            textResult =
                                textResult +
                                this.appendUnitofMeasure(
                                    item.unitSys,
                                    this.getTitleByFieldName(element),
                                    item[element]
                                ) +
                                ' ';
                        }
                    }
                });
                textResult = textResult + (this.ComponentKind === 'Memo' ? '\n' : '<br>');
            } else {
                if (this.items.length > 0) {
                    this.items.forEach(item => {
                        keys = Object.keys(item);
                        keys.forEach(element => {
                            if (
                                item[element] != '' &&
                                item[element] != '0' &&
                                item[element] != null
                            ) {
                                if (
                                    element != 'therapistCode' &&
                                    element != 'recNo' &&
                                    element != 'notes' &&
                                    element != 'bmi' &&
                                    element != 'bsa' &&
                                    element != 'o2inhaled'
                                ) {
                                    textResult =
                                        textResult +
                                        this.appendUnitofMeasure(
                                            item.unitSys,
                                            this.getTitleByFieldName(element),
                                            item[element]
                                        ) +
                                        ' ';
                                }
                            }
                        });
                        textResult = textResult + (this.ComponentKind === 'Memo' ? '\n' : '<br>');
                    });
                }
            }

            return textResult;
        },

        FormatTreatmentPlanDates(arr) {
            arr.problems.forEach(function(item) {
                if (item.problem.dateTimeCreate)
                    item.problem.dateTimeCreate = Utils.formatterDateToString(
                        item.problem.dateTimeCreate
                    );
                if (item.problem.probDate)
                    item.problem.probDate = Utils.formatterDateToString(item.problem.probDate);

                item.goals.forEach(function(g) {
                    if (g.goal.dateAchieve)
                        g.goal.dateAchieve = Utils.formatterDateToString(g.goal.dateAchieve);
                    if (g.goal.dateExp)
                        g.goal.dateExp = Utils.formatterDateToString(g.goal.dateExp);
                    if (g.goal.dateSet)
                        g.goal.dateSet = Utils.formatterDateToString(g.goal.dateSet);
                    if (g.goal.dateTimeCreate)
                        g.goal.dateTimeCreate = Utils.formatterDateToString(g.goal.dateTimeCreate);

                    g.goal.statusobj = { code: g.goal.status, description: g.goal.status };

                    g.objectives.forEach(function(o) {
                        if (o.objective.dateAchieve)
                            o.objective.dateAchieve = Utils.formatterDateToString(
                                o.objective.dateAchieve
                            );
                        if (o.objective.dateExp)
                            o.objective.dateExp = Utils.formatterDateToString(o.objective.dateExp);
                        if (o.objective.dateSet)
                            o.objective.dateSet = Utils.formatterDateToString(o.objective.dateSet);
                        if (o.objective.dateTimeCreate)
                            o.objective.dateTimeCreate = Utils.formatterDateToString(
                                o.objective.dateTimeCreate
                            );

                        o.interventions.forEach(function(i) {
                            if (i.dateTimeCreate)
                                i.dateTimeCreate = Utils.formatterDateToString(i.dateTimeCreate);
                            if (i.signedDate)
                                i.signedDate = Utils.formatterDateToString(i.signedDate);
                            if (i.startDate) i.startDate = Utils.formatterDateToString(i.startDate);
                        });
                    });
                });
            });

            arr.signatures.forEach(function(sig) {
                if (sig.coSignedDate)
                    sig.coSignedDate = Utils.formatterDateToString(sig.coSignedDate);
                if (sig.patientSignedDate)
                    sig.patientSignedDate = Utils.formatterDateToString(sig.patientSignedDate);
                if (sig.signedDate) sig.signedDate = Utils.formatterDateToString(sig.signedDate);

                if (sig.guardianSignedDate)
                    sig.guardianSignedDate = Utils.formatterDateToString(sig.guardianSignedDate);

                if (sig.isPatientSigned === true) {
                    sig.CheckRefuseReadOnly = true;
                    sig.CheckGuardianReadOnly = true;
                    sig.SelectGuardianReadOnly = true;
                } else {
                    sig.CheckRefuseReadOnly = false;
                    sig.CheckGuardianReadOnly = false;
                    sig.SelectGuardianReadOnly = false;
                }
                sig.ProviderModel = {
                    therapistCode: sig.therapistCode,
                    therapistName: sig.therapistName
                };
                sig.CoProviderModel = {
                    coTherapistCode: sig.coTherapistCode,
                    coTherapistName: sig.coTherapistName
                };
            });
        },

        PopulatePatientTitle() {
            const {
                dob,
                dateFrom,
                dateTo,
                age,
                programName,
                patientName,
                ageFormatted
            } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);

            if (
                this.$route.name.includes('treatmentplanbase-Clinical') ||
                this.$route.name.includes('Clinical-Notes')
            ) {
                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }
            if (this.$route.name.includes('treatmentplanbase-Scheduler')) {
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';
                this.PatientTitle.dob = this.patient.dob;
                //this.PatientTitle.fullName = this.patient.firstname + ' '+ this.patient.lastname;
            }
        },
        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.PatientCode);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        },
        Search() {
            //this.Loading = true;
            //this.$emit('load', this.Loading);
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            // this.getTP();
        },

        OpenModalEditIntervention(item, i) {
            this.InterventionEdit = i;
            this.InterventionEdit.amountObj = { code: i.amount, description: i.amount };
            this.InterventionEdit.frequencyObj = { code: i.frequency, description: i.frequency };
            this.InterventionEdit.durationObj = { code: i.duration, description: i.duration };
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleEditIntervention = true;
        },

        OpenModalEditInterventionMedez(item, i) {
            this.InterventionEdit = i;
            this.InterventionEdit.amountObj = { code: i.amount, description: i.amount };
            this.InterventionEdit.frequencyObj = { code: i.frequency, description: i.frequency };
            this.InterventionEdit.durationObj = { code: i.duration, description: i.duration };
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleEditInterventionMedez = true;
        },

        OpenModalEditInterventionWiley(item, i) {
            this.InterventionEdit = i;
            this.InterventionEdit.amountObj = { code: i.amount, description: i.amount };
            this.InterventionEdit.frequencyObj = { code: i.frequency, description: i.frequency };
            this.InterventionEdit.durationObj = { code: i.duration, description: i.duration };
            this.ProblemRecId = item.problem.probRecId;
            this.groupId = item.problem.groupId;
            this.headerId = item.problem.headerId;
            this.probCode = item.problem.probCode;
            this.VisibleEditInterventionWiley = true;
        },

        ModalTPEditIntervention() {
            this.VisibleEditIntervention = false;
        },

        ModalTPEditInterventionWiley() {
            this.VisibleEditInterventionWiley = false;
        },

        ModalTPEditInterventionMedez() {
            this.VisibleEditInterventionMedez = false;
        },

        ViewTP(item) {
            this.$emit('getVisibleMenu', this.OptionsRightMenu);

            this.NotesId = item.notesid;
            this.TreatmentPlanType = item.customframe;
            let copy = { ...item };
            this.TreatmentPlanTypeCopy = copy.customframe;

            if (item.customframe === 'TfmWileyTreatmentPlanNotes') {
                if (
                    this.$route.name.includes('treatmentplanbase-Clinical') ||
                    this.$route.name.includes('Clinical-Notes') ||
                    this.$route.name.includes('groupnotes-Dashboard')
                ) {
                    //   this.$router.push({ name: "WyTreatmentplan-Clinical", params: { id: this.$route.params.id, recordid: this.$route.params.recordid, notesid: item.notesid } });
                    this.showListing(false);
                    this.getProblems();
                } /*else{
            this.$router.push({ name: "WyTreatmentplan-Appointment", params: { id: this.$route.params.id, recordid: this.AppoitmentList[0].admissionRecordId.trim(), actId: this.$route.params.actId, notesid: item.notesid } });
        }*/
            }

            if (item.customframe === 'TFRMTREATMENTPLANNOTES') {
                if (
                    this.$route.name.includes('treatmentplanbase-Clinical') ||
                    this.$route.name.includes('Clinical-Notes') ||
                    this.$route.name.includes('groupnotes-Dashboard')
                ) {
                    // this.$router.push({ name: "MdTreatmentplan-Clinical", params: { id: this.$route.params.id, recordid: this.$route.params.recordid, notesid: item.notesid  } });
                    this.showListing(false);
                    this.getProblems();
                } /*else{
            this.$router.push({ name: "appointmentDB-MdTreatmentplan", params: { id: this.$route.params.id, recordid:this.AppoitmentList[0].admissionRecordId.trim(), actId: this.$route.params.actId, notesid: item.notesid } });
        }*/
            }
        },

        DoCalls() {
            if (
                this.$route.name.includes('treatmentplanbase-Scheduler') ||
                this.$route.name.includes('appointmentDB-Dashboard')
            ) {
                let param = {
                    PageNumber: this.currentPage,
                    PageSize: this.perPage,
                    PatientCode: this.PatientCode,
                    ActivityId: this.$route.params.actId
                };
                TreatmentPlan.getAppointmentByActivity(param)
                    .then(response => {
                        if (response.status == '200' && response.data && response.data.length > 0) {
                            this.AppoitmentList = response.data;
                            this.visibleTable =
                                this.AppoitmentList[0].admissionRecordId === null ||
                                this.AppoitmentList[0].admissionRecordId === ''
                                    ? false
                                    : true;
                            if (this.visibleTable) {
                                this.getTP();
                            }

                            this.Load = false;
                        }
                    })
                    .catch(error => {
                        this.Load = false;
                        if (!error.response) {
                            // network error
                            this.showMessage(
                                this.$t('Shared.PatientAllergies'),
                                this.$t('Msg.retrieveInfo'),
                                'error'
                            );
                        } else {
                            this.showMessage(this.$t('Shared.PatientAllergies'), error, 'error');
                        }
                    });
            } else {
                this.getTP();
            }
        },

        getTP() {
            this.Load = true;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.parameter.PatientCode = this.PatientCode;
            this.parameter.IsTreatmentPlan = true;
            this.parameter.showAll = false;

            TreatmentPlan.getTPList(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                    if (this.items.length === 0) {
                        this.ShowMessageIsEmpty = true;
                    }

                    if (this.items.length === 1) {
                        this.NotesId = this.items[0].notesid;
                        this.showListing(false);
                        this.TreatmentPlanType = this.items[0].customframe;
                        let copy = { ...this.items[0] };
                        this.TreatmentPlanTypeCopy = copy.customframe;
                        // this.isListing = false;

                        this.getProblems();
                        this.isEditMode = true;

                        /* let item = this.items[0];
            if(item.customframe === 'TfmWileyTreatmentPlanNotes'){
              if(this.$route.name.includes('treatmentplanbase-Clinical')){
                this.$router.push({ name: "WyTreatmentplan-Clinical", params: { id: this.$route.params.id, recordid: this.$route.params.recordid, notesid: item.notesid } });
              }else{
                this.$router.push({ name: "WyTreatmentplan-Appointment", params: { id: this.$route.params.id, recordid: this.AppoitmentList[0].admissionRecordId.trim(), actId: this.$route.params.actId, notesid: item.notesid } });
              }
            }

            if(item.customframe === 'TFRMTREATMENTPLANNOTES'){
              if(this.$route.name.includes('treatmentplanbase-Clinical')){
                this.$router.push({ name: "MdTreatmentplan-Clinical", params: { id: this.$route.params.id, recordid: this.$route.params.recordid, notesid: item.notesid  } });
              }else{
                this.$router.push({ name: "appointmentDB-MdTreatmentplan", params: { id: this.$route.params.id, recordid:this.AppoitmentList[0].admissionRecordId.trim(), actId: this.$route.params.actId, notesid: item.notesid } });
              }
            }*/
                    }

                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$t('Shared.PatientAllergies'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$t('Shared.PatientAllergies'), error, 'error');
                    }
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            // this.getTP();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            // this.getTP();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },

        selectThirdRow() {
            this.$refs.selectableTable.selectRow(2);
        },

        unselectThirdRow() {
            this.$refs.selectableTable.unselectRow(2);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename = this.currentAppointmentDB.activitytypename;
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(
                this.currentAppointmentDB.transdate
            )} ${this.currentAppointmentDB.timein}`;
        }
    },

    created() {
        this.EmployeeCode = this.$store.state.employeeCode;
        this.getEmployeeProvider();
        this.getEmployeeCoProvider();
        window.addEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
            }.bind(this)
        );
    },

    async mounted() {
        this.Load = true;
        this.isEditMode = this.isOpenInEmployeeInbox;

        if (this.isOpenInEmployeeInbox) {
            this.TreatmentPlanType = this.CustomFrame;
            this.TreatmentPlanTypeCopy = this.CustomFrame;
            this.NotesId = this.NotesIdByEmployeeInbox;
        }

        if (this.isEditMode && this.isOpenInEmployeeInbox) {
            this.getProblems();
        }
        ////  this.getTP();
        this.DoCalls();
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('treatmentplanbase-Clinical')
            ? EnumService.ClinicalItems
            : EnumService.AppointmentItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.isReadOnly = await this.$store.state.isTreatmentPlanClinicalEHRReadOnly;

        if (this.$route.name.includes('treatmentplanbase-Scheduler')) {
            this.GetPatientByCode();
            await this.getCurrentAppointment();
        }

        if (
            this.$route.name.includes('treatmentplanbase-Clinical') ||
            this.$route.name.includes('Clinical-Notes')
        ) {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.AdmissionRecordId);
            this.RegistrationInfo.dob =
                this.RegistrationInfo && this.RegistrationInfo.dob
                    ? Utils.formatterDateToString(this.RegistrationInfo.dob)
                    : null;
            /* eslint-disable no-unused-vars */
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            // if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? '0' : age;
            this.IsClinical = dateTo ? false : true;
        }
        this.PopulatePatientTitle();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
};
</script>
